import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import router from '@/router'
import { getField, updateField } from 'vuex-map-fields';
import createEasyFirestore from 'vuex-easy-firestore'
import { Base64 } from 'js-base64'
import axios from 'axios'
//import { table } from 'table'
import dateFormat from 'dateformat'
import shared from './../shared'

this.createVariationName = shared.createVariationName
this.createVariationAvecorSku = shared.createVariationAvecorSku

Vue.use(Vuex)


const ordersModule = {
    firestorePath: 'orders',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'order',
    statePropName: 'orders',
    sync: {debounceTimerMs: 100},
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        },
      }
}

const companiesModule = {
    firestorePath: 'companies',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'company',
    statePropName: 'companies',
    sync: {},
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const contactsModule = {
    firestorePath: 'contacts',
    firestoreRefType: 'collection', 
    moduleName: 'contact',
    statePropName: 'contacts',
    sync: {},
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const staffModule = {
    firestorePath: 'staff',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'staff',
    statePropName: 'staff',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}


const wholesaleCompaniesModule = {
    firestorePath: 'wholesaleCompanies',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'wholesaleCompany',
    statePropName: 'wholesaleCompanies',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}
const printShopsModule = {
    firestorePath: 'printShops',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'printShop',
    statePropName: 'printShops',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const otherPartnersModule = {
    firestorePath: 'otherPartners',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'otherPartner',
    statePropName: 'otherPartners',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const orderedProductsModule = {
    firestorePath: 'orderedProducts',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'orderedProduct',
    statePropName: 'orderedProducts',
    //sync: {debounceTimerMs: 1},
    sync: {
        debounceTimerMs: 100
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const productsModule = {
    firestorePath: 'products',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'product',
    statePropName: 'products',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const productVariationsModule = {
    firestorePath: 'productVariations',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'productVariation',
    statePropName: 'productVariations',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const internalProductDataModule = {
    firestorePath: 'internalProductData',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'internalProductData',
    statePropName: 'internalProductData',
    sync: {
        /*where: [ // an array of arrays
            ['shared', 'array-contains', 'tomi'] // example
        ]*/
    },
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}

const productTagsModule = {
    firestorePath: 'productTags',
    firestoreRefType: 'collection', // or 'doc'
    moduleName: 'productTag',
    statePropName: 'productTags',
    serverChange: {
        modifiedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc)
        },
        addedHook: function (updateStore, doc, id, store, source, change) { 
            updateStore(doc); 
        },
        removedHook: function (updateStore, doc, id, store) { 
            updateStore(doc); 
        }
    },
    sync: {
        insertHook: function (updateStore, doc, store) { 
            updateStore(doc)
         },
        patchHook: function (updateStore, doc, store) { 
            updateStore(doc)
        },
        deleteHook: function (updateStore, id, store) { 
            updateStore(id) 
        }
    }
}
const pricingVariablesModule = {
	firestorePath: 'config/pricingVariables',
	firestoreRefType: 'doc',
	moduleName: 'pricingVariables',
	statePropName: 'pricingVariables',
	sync: {debounceTimerMs: 1},
    serverChange: {}
}

const easyFirestore = createEasyFirestore([
    ordersModule, 
    companiesModule, 
    staffModule, 
    contactsModule, 
    orderedProductsModule, 
    productsModule, 
    productVariationsModule, 
    internalProductDataModule,
    //productTagsModule,
    wholesaleCompaniesModule,
    printShopsModule,
    otherPartnersModule,
    pricingVariablesModule
], {logging: true})

function wait(ms){
    var start = new Date().getTime();
    var end = start;
    while(end < start + ms) {
      end = new Date().getTime();
   }
 }

export const store = new Vuex.Store({
  state: {
    searchOrders:{},
    searchOrderedProducts:{},
    selectedView: {
        officeView: window.location.hostname.includes("-dev") ? "orders" : "orders",
        warehouseView: "orders",
        salesView: "newOrder",
        clientView: "store",
        adminView: "staff"
    },
    isSyncOrderToNetvisorActive:false,
    device: window.innerWidth <= 800 ? 'mobile' : 'desktop',
    reserved:{},
    modals: {
        orders:{
            sendProgress:{
                visible:false
            },
            invoicing:{
                visible:false,
                orderId:null,
                env:null
            }
        },
        prices:{
            printShop:{
                new:{
                    visible:false
                }
            }
        },
        report:{
            competition:{
                new:{
                    visible:false,
                    data:null
                }
            }
        },
        development:{
            new:{
                visible:false,
            },
            edit:{
                visible:false,
                itemId:null
            }
        },
        additionalSales:{
            newLead:{
                visible:false
            }
        },
        orderedProduct:{
            new:{
                visible:false,
                orderId:null
            },
            edit:{
                visible:false,
                orderedProductId:null
            }
        },
        company:{
            new:{
                visible:false,
            }
        },
        product:{
            new:{
                visible:false,
            },
            edit:{
                visible:false,
                productId:null
            },
            bulkEdit:{
                visible:false
            }
        },
        batches:{
            new:{
                visible:false,
                productId:null,
                productVariationId:null
            }
        }
    },
    views: {
        orders:{
            pinnedOrders:[],
            selectedOrder:{
                companyId:null,
                orderId:null,
                companyName:null
            },
            selectedCompany:{
                companyId:null
            },
            orderedProductsStatuses:{}
        },
        margins:{
            selectedOrder:{
                companyId:null,
                orderId:null,
                companyName:null,
                orderedProductId:null
            },
            selectedCompany:{
                companyId:null
            },
            orderedProductsStatuses:{}
        },
        products:{
            selectedProduct:{
                productId:null
            },
            mediaManagerOpen:false
        },
        shops:{
            selectedProduct:{
                productId:null
            },
            selectedCompany:{
                companyId:null
            }
        },
        prices:{
            selectedProduct:{
                productId:null
            },
        },
        stock:{
            selectedProduct:{
                productId:null
            },
            selectedWholesaleCompany:{
                wholesaleCompanyId:null
            },
            selectedOrder:{
                orderId:null
            }
        },
        partners:{
            selectedWholesaleCompany:{
                wholesaleCompanyId:null
            }
        },
        companies:{
            selectedCompany:{
                companyId:null
            }
        },
        store:{
            cartProducts: []
        },
        salesConsole: {} 
    },
    settings: {
        companySharing:{
            'WEKfjCcgRvcKWX4nnUqMwsFpeaP2'/*KATRI*/:['p2VRFkTz4JUzqkGoTPUt4CWQAxa2'/*TOMI*/,'L3xv520BgJQdTTNS0aP2EqVuO1j2'/*JERE*/]
        },
        /* paymentTerms:[
            '14 päivää netto','1 päivää netto','7 päivää netto','10 päivää netto','12 päivää netto','20 päivää netto','21 päivää netto','30 päivää netto','45 päivää netto','60 päivää netto','90 päivää netto'
        ], */
        paymentTerms:[
            {id:14,text:'14 päivää netto'},{id:1,text:'1 päivää netto'},{id:7,text:'7 päivää netto'},{id:10,text:'10 päivää netto'},{id:12,text:'12 päivää netto'},{id:20,text:'20 päivää netto'},{id:21,text:'21 päivää netto'},{id:30,text:'30 päivää netto'},{id:45,text:'45 päivää netto'},{id:60,text:'60 päivää netto'},{id:90,text:'90 päivää netto'}
        ],
        vatPercentages:{
            "25_5":{text:"25,5%",id:'25_5',netvisorText:'25,5'},
            "14":{text:"14%",id:'14',netvisorText:'14'},
            "10":{text:"10%",id:'10',netvisorText:'10'},
            "0":{text:"0%",id:'0',netvisorText:'0'},
        },
        isServer:window.location.hostname.includes("-dev") ? false : true,
        loadingOverlay: {
            show:false,
            label:"Ladataan"
        },
        weeksArray:["",
            "1/2025","2/2025","3/2025","4/2025","5/2025","6/2025","7/2025","8/2025","9/2025","10/2025","11/2025","12/2025","13/2025","14/2025","15/2025","16/2025","17/2025","18/2025","19/2025","20/2025","21/2025","22/2025","23/2025","24/2025","25/2025","26/2025","27/2025","28/2025","29/2025","30/2025","31/2025","32/2025","33/2025","34/2025","35/2025","36/2025","37/2025","38/2025","39/2025","40/2025","41/2025","42/2025","43/2025","44/2025","45/2025","46/2025","47/2025","48/2025","49/2025","50/2025","51/2025","52/2025",
            "1/2023","2/2023","3/2023","4/2023","5/2023","6/2023","7/2023","8/2023","9/2023","10/2023","11/2023","12/2023","13/2023","14/2023","15/2023","16/2023","17/2023","18/2023","19/2023","20/2023","21/2023","22/2023","23/2023","24/2023","25/2023","26/2023","27/2023","28/2023","29/2023","30/2023","31/2023","32/2023","33/2023","34/2023","35/2023","36/2023","37/2023","38/2023","39/2023","40/2023","41/2023","42/2023","43/2023","44/2023","45/2023","46/2023","47/2023","48/2023","49/2023","50/2023","51/2023","52/2023",
            "1/2024","2/2024","3/2024","4/2024","5/2024","6/2024","7/2024","8/2024","9/2024","10/2024","11/2024","12/2024","13/2024","14/2024","15/2024","16/2024","17/2024","18/2024","19/2024","20/2024","21/2024","22/2024","23/2024","24/2024","25/2024","26/2024","27/2024","28/2024","29/2024","30/2024","31/2024","32/2024","33/2024","34/2024","35/2024","36/2024","37/2024","38/2024","39/2024","40/2024","41/2024","42/2024","43/2024","44/2024","45/2024","46/2024","47/2024","48/2024","49/2024","50/2024","51/2024","52/2024",
            "1/2022","2/2022","3/2022","4/2022","5/2022","6/2022","7/2022","8/2022","9/2022","10/2022","11/2022","12/2022","13/2022","14/2022","15/2022","16/2022","17/2022","18/2022","19/2022","20/2022","21/2022","22/2022","23/2022","24/2022","25/2022","26/2022","27/2022","28/2022","29/2022","30/2022","31/2022","32/2022","33/2022","34/2022","35/2022","36/2022","37/2022","38/2022","39/2022","40/2022","41/2022","42/2022","43/2022","44/2022","45/2022","46/2022","47/2022","48/2022","49/2022","50/2022","51/2022","52/2022","53/2022",
        ],
        weeksArrayDates:["",
            "1/2025 (30.12-5.1)","2/2025 (6.1-12.1)","3/2025 (13.1-19.1)","4/2025 (20.1-26.1)","5/2025 (27.1-2.2)","6/2025 (3.2-9.2)","7/2025 (10.2-16.2)","8/2025 (17.2-23.2)","9/2025 (24.2-2.3)","10/2025 (3.3-9.3)","11/2025 (10.3-16.3)","12/2025 (17.3-23.3)","13/2025 (24.3-30.3)","14/2025 (31.3-6.4)","15/2025 (7.4-13.4)","16/2025 (14.4-20.4)","17/2025 (21.4-27.4)","18/2025 (28.4-4.5)","19/2025 (5.5-11.5)","20/2025 (12.5-18.5)","21/2025 (19.5-25.5)","22/2025 (26.5-1.6)","23/2025 (2.6-8.6)","24/2025 (9.6-15.6)","25/2025 (16.6-22.6)","26/2025 (23.6-29.6)","27/2025 (30.6-6.7)","28/2025 (7.7-13.7)","29/2025 (14.7-20.7)","30/2025 (21.7-27.7)","31/2025 (28.7-3.8)","32/2025 (4.8-10.8)","33/2025 (11.8-17.8)","34/2025 (18.8-24.8)","35/2025 (25.8-31.8)","36/2025 (1.9-7.9)","37/2025 (8.9-14.9)","38/2025 (15.9-21.9)","39/2025 (22.9-28.9)","40/2025 (29.9-5.10)","41/2025 (6.10-12.10)","42/2025 (13.10-19.10)","43/2025 (20.10-26.10)","44/2025 (27.10-2.11)","45/2025 (3.11-9.11)","46/2025 (10.11-16.11)","47/2025 (17.11-23.11)","48/2025 (24.11-30.11)","49/2025 (1.12-7.12)","50/2025 (8.12-14.12)","51/2025 (15.12-21.12)","52/2025 (22.12-28.12)",
            "1/2024 (1.1-7.1)","2/2024 (8.1-14.1)","3/2024 (15.1-21.1)","4/2024 (22.1-28.1)","5/2024 (29.1-4.2)","6/2024 (5.2-11.2)","7/2024 (12.2-18.2)","8/2024 (19.2-25.2)","9/2024 (26.2-3.3)","10/2024 (4.3-10.3)","11/2024 (11.3-17.3)","12/2024 (18.3-24.3)","13/2024 (25.3-31.3)","14/2024 (1.4-7.4)","15/2024 (8.4-14.4)","16/2024 (15.4-21.4)","17/2024 (22.4-28.4)","18/2024 (29.4-5.5)","19/2024 (6.5-12.5)","20/2024 (13.5-19.5)","21/2024 (20.5-26.5)","22/2024 (27.5-2.6)","23/2024 (3.6-9.6)","24/2024 (10.6-16.6)","25/2024 (17.6-23.6)","26/2024 (24.6-30.6)","27/2024 (1.7-7.7)","28/2024 (8.7-14.7)","29/2024 (15.7-21.7)","30/2024 (22.7-28.7)","31/2024 (29.7-4.8)","32/2024 (5.8-11.8)","33/2024 (12.8-18.8)","34/2024 (19.8-25.8)","35/2024 (26.8-1.9)","36/2024 (2.9-8.9)","37/2024 (9.9-15.9)","38/2024 (16.9-22.9)","39/2024 (23.9-29.9)","40/2024 (30.9-6.10)","41/2024 (7.10-13.10)","42/2024 (14.10-20.10)","43/2024 (21.10-27.10)","44/2024 (28.10-3.11)","45/2024 (4.11-10.11)","46/2024 (11.11-17.11)","47/2024 (18.11-24.11)","48/2024 (25.11-1.12)","49/2024 (2.12-8.12)","50/2024 (9.12-15.12)","51/2024 (16.12-22.12)","52/2024 (23.12-29.12)",    
            "1/2023","2/2023","3/2023","4/2023","5/2023","6/2023","7/2023","8/2023","9/2023","10/2023","11/2023","12/2023","13/2023","14/2023","15/2023","16/2023","17/2023","18/2023","19/2023","20/2023","21/2023","22/2023","23/2023","24/2023","25/2023","26/2023","27/2023","28/2023","29/2023","30/2023","31/2023","32/2023","33/2023","34/2023","35/2023","36/2023","37/2023","38/2023","39/2023","40/2023 (2.10-8.10)","41/2023 (9.10-15.10)","42/2023 (16.10-22.10)","43/2023 (23.10-29.10)","44/2023 (30.10-5.11)","45/2023 (6.11-12.11)","46/2023 (13.11-19.11)","47/2023 (20.11-26.11)","48/2023 (27.11-3.12)","49/2023 (4.12-10.12)","50/2023 (11.12-17.12)","51/2023 (18.12-24.12)","52/2023 (25.12-31.12)",
            "1/2022 (3.1-9.1)","2/2022 (10.1-16.1)","3/2022 (17.1-23.1)","4/2022 (24.1-30.1)","5/2022 (31.1-6.2)","6/2022 (7.2-13.2)","7/2022 (14.2-20.2)","8/2022 (21.2-27.2)","9/2022 (28.2-6.3)","10/2022 (7.3-13.3)","11/2022 (14.3-20.3)","12/2022 (21.3-27.3)","13/2022 (28.3-3.4)","14/2022 (4.4-10.4)","15/2022 (11.4-17.4)","16/2022 (18.4-24.4)","17/2022 (25.4-1.5)","18/2022 (2.5-8.5)","19/2022 (9.5-15.5)","20/2022 (16.5-22.5)","21/2022 (23.5-29.5)","22/2022 (30.5-5.6)","23/2022 (6.6-12.6)","24/2022 (13.6-19.6)","25/2022 (20.6-26.6)","26/2022 (27.6-3.7)","27/2022 (4.7-10.7)","28/2022 (11.7-17.7)","29/2022 (18.7-24.7)","30/2022 (25.7-31.7)","31/2022 (1.8-7.8)","32/2022 (8.8-14.8)","33/2022 (15.8-21.8)","34/2022 (22.8-28.8)","35/2022 (29.8-4.9)","36/2022 (5.9-11.9)","37/2022 (12.9-18.9)","38/2022 (19.9-25.9)","39/2022 (26.9-2.10)","40/2022 (3.10-9.10)","41/2022 (10.10-16.10)","42/2022 (17.10-23.10)","43/2022 (24.10-30.10)","44/2022 (31.10-6.11)","45/2022 (7.11-13.11)","46/2022 (14.11-20.11)","47/2022 (21.11-27.11)","48/2022 (28.11-4.12)","49/2022 (5.12-11.12)","50/2022 (12.12-18.12)","51/2022 (19.12-25.12)","52/2022 (26.12-1.1)","53/2022 (2.1-8.1)"
        ],
        defaultDeliveryCharge:24.9,
        loaded:false,
        companySelectedInModel:null, // remove this
        urlId: '',
        toggleMandatory:true,
        ordersSearch:'',
        ordersSearchTerm:'',
        companiesSearch:'',
        marginsSearch:'',
        marginsSearchInvoiced:'',
        marginsSearchTerm:'',
        orderProductsSearch:'',
        productsSearch:'',
        productsSearchTerm:'',
        staffSearchTerm:'',
        wholesaleCompaniesSearchTerm:'',
        printShopsSearchTerm:'',
        otherPartnersSearchTerm:'',
        debug:false,
        rowsPerPageItems:[15,30],
        treeIconsize: 12,
        menuIconSize: 12,
        tableIconSize: 14,
        tableActionIconsSize: 11,
        tableSelectIconsSize: 14,
        priceConditions:{
            /* no_condition:"", */
            no_print_plus_minimum:"Ilm. painatus + minimiveloitus"
        },
        typesOfEmailSends:{
            order_confirmation:{id:"order_confirmation", fi:"Tilausvahvistus"},
            material_request:{id:"material_request", fi:"Materiaalipyyntö"},
            logo_reminder:{id:"logo_reminder", fi:"Logo muistutus"},
            draft_reminder_wholesale:{id:"draft_reminder_wholesale", fi:"Vedos toimittajalta muistutus"},
            order_created_reminder_wholesale:{id:"order_created_reminder_wholesale",fi:"Tilaus tehty muistutus"},
            draft_reminder_customer:{id:"draft_reminder_customer",fi:"Vedos muistutus asiakkaalle"},
            sales_asked_to_contact_for_logo:{id:'sales_asked_to_contact_for_logo', fi:'Myyjää pyydetty kontaktoimaan (materiaali)'},
            sales_asked_to_contact_for_draft:{id:'sales_asked_to_contact_for_draft', fi:"Myyjää pyydetty kontaktoimaan (vedos)"}
        },
        
        batchArrivalDateStatusColors:{
            arrived: "#2ECC40",
            shelfed: "#2ECC40",
            ok: "#ccc",
            exceeded:"#ff2f00",
            within3days:"#ff982e", 
            within5days:"#ff982e", // Purple
        },
        metrics:{
            orders:{fi:"Tilaukset"},
            newCustomers:{fi:"Uudet Asiakkat"},
            margins:{fi:"Kate"},
            sales:{fi:"Myynti"},
            agreedVisits:{fi:"Sovitut Tapaamiset"}
        },
        batchStatusArray: [
            {text:"Tilattu Tukkurilta", id: "batchOrdered"}, 
            {text:"Saapunut Varastolle", id: "batchArrivedToWarehouse"}, 
            {text:"Osittain Hyllytetty", id: "batchPartiallyShelfed"},
            {text:"Hyllytetty", id: "batchShelfed"} 
        ],
        industries:{
            pharmacies:{id:"pharmacies",fi:"Apteekit"},
            car_dealerships:{id:"car_dealerships", fi:"Autoliikket"},
            power_plants:{id:"power_plants",fi:"Energialaitokset"},
            personnel_leasing:{id:"personnel_leasing",fi:"Henkilöstövuokraus"},
            nursing_homes:{id:"nursing_homes",fi:"Hoivakodit"},
            gas_stations:{id:"gas_stations",fi:"Huoltoasemat"},
            hotels:{id:"hotels",fi:"Hotellit"},
            property_management_companies:{id:"property_management_companies", fi:"Isännöintitoimistot"},
            waste_management:{id:"waste_management",fi:"Jätehuolto"},
            cities_and_municipalities:{id:"cities_and_municipalities",fi:"Kaupungit/Kunnat"},
            kitchen_industry:{id:"kitchen_industry",fi:"Keittiöala"},
            real_estate_brokerage:{id:"real_estate_brokerage",fi:"Kiinteistövälitys"},
            property_maintenance:{id:"property_maintenance",fi:"Kiinteistöhuolto"},
            cosmetics:{id:"cosmetics", fi:"Kosmetiikka"},
            schools:{id:"schools",fi:"Koulut ja lukiot"},
            transportation_and_storage:{id:"transportation_and_storage",fi:"Kuljetus/Varastointi"},
            gyms:{id:"gyms",fi:"Kuntosalit"},
            unions_and_associations:{id:"unions_and_associations",fi:"Liitot ja Yhdistykset"},
            locksmiths:{id:"locksmiths",fi:"Lukkoliikkeet"},
            agriculture:{id:"agriculture",fi:"Maatalous"},
            military:{id:"military",fi:"Maanpuolustus"},
            marketing_agencies:{id:"marketing_agencies", fi:"Markkinointitoimistot"},
            motor_vehicles:{id:"motor_vehicles", fi:"Moottoriajoneuvot"},
            motor_vehicles_repair:{id:"motor_vehicles_repair", fi:"Moottoriajoneuvojen korjaus"},
            museums:{id:"museums",fi:"Museot"},
            cooperative_societies:{id:"cooperative_societies",fi:"Osuuskunnat"},
            rescue_services:{id:"rescue_services",fi:"Pelastuslaitokset"},
            wood_production:{id:"wood_production",fi:"Puutuotanto"},
            construction_companies:{id:"construction_companies",fi:"Rakennusliikkeet"},
            saw_companies:{id:"saw_companies",fi:"Sahat"},
            hospitals:{id:"hospitals",fi:"Sairaalat"},
            congregations:{id:"congregations",fi:"Seurakunnat"},
            electrical_and_hvac:{id:"electrical_and_hvac",fi:"Sähkö/LVI"},
            industrial_companies:{id:"industrial_companies",fi:"Teollisuus"},
            accounting_companies:{id:"accounting_companies", fi:"Tilitoimistot"},
            wholesalers:{id:"wholesalers",fi:"Tukkuliikkeet"},
            universities:{id:"universities",fi:"Yliopistot"},
            insurance_companies:{id:"insurance_companies", fi:"Vakuutus alan yritykset"},
            government:{id:"government",fi:"Valtio"},
            waterworks:{id:"waterworks",fi:"Vesilaitokset"},
            other:{id:"other",fi:"Muu"}
        },
        partnerContactTypesArray: [
            {text:"Tilauskontaktihenkilö", id: "ordersContact"}, 
            {text:"Muu kontaktihenkilö", id: "otherContact"}, 
        ],
        partnerContactRoles: [
            {text:"--", id: "notSelected"}, 
            {text:"Myynti", id: "sales"}, 
            {text:"Tilaukset", id: "orders"}, 
            {text:"Info", id: "info"}, 
            {text:"Export", id: "export"}, 
            {text:"Import", id: "import"}, 
            {text:"Kuljetus", id: "delivery"}, 
            {text:"Varasto", id: "warehouse"}, 
            {text:"Toimitusjohtaja", id: "ceo"}, 
            {text:"Omistaja", id: "owner"}, 
            {text:"Muu", id: "other"}, 
        ],
        orderStatusArray: [
            {text:"Uusi", id: "new"}, 
            {text:"Käsittelyssä", id: "inProcess"},
            {text:"Tuotteet tilattu", id: "productsOrdered"}, 
            {text:"Tuotteet lähetetty", id: "productsSentToCustomer"}, 
            {text:"Laskutettu", id: "invoiced"}
        ],
        sampleOrderStatusArray: [
            {text:"Uusi", id: "new"}, 
            {text:"Tuotteet lähetetty", id: "productsSentToCustomer"}, 
            {text:"Tuotteet palautettu", id: "productsReturnedToWarehouse"}, 
        ],
        // REMEMBER TO UPDATE ALSO IN FUNCTIONS IF UPDATING
        packageTypes: {
            singleUnits: {fi:"Yksittäiset kappaleet", id: "singleUnits"}, 
            case: {fi:"Rasia", id: "case"},
            box: {fi:"Laatikko", id: "box"}, 
            pair: {fi:"Pari", id: "pair"}, 
            litre:{fi:"Litra", id:"litre"},
            kg:{fi:"Kg", id:"kg"},
            canister:{fi:"Kanisteri", id:"canister"},
        },
        // REMEMBER TO UPDATE ALSO IN FUNCTIONS IF UPDATING
        genders: {
            male: {fi:"Miehet", id:"male"},
            female: {fi:"Naiset", id:"female"}
        },
        // REMEMBER TO UPDATE ALSO IN FUNCTIONS IF UPDATING
        sizes:["5XS","4XS","XXXS","XXS","XS","S","M","L","XL","XXL","XXXL","4XL","5XL","6XL","3","4","5","6","7","8","9","10","11","12","13"],//"A4","A5","A6"
        // REMEMBER TO UPDATE ALSO IN FUNCTIONS IF UPDATING
        colors:{
            '001':{id:'001',classes:[1],classNames:["Mustat"],fi:"Musta",en:"Black", oldColor:"Musta Vetoketju"},
            '002':{id:'002',classes:[1],classNames:["Mustat"],fi:"Sysimusta",en:"Jet Black"},
            '003':{id:'003',classes:[1],classNames:["Mustat"],fi:"Pehmeä musta",en:"Soft Black"},
            '004':{id:'004',classes:[1],classNames:["Mustat"],fi:"Käytetty musta",en:"Used Black"},
            '005':{id:'005',classes:[1],classNames:["Mustat"],fi:"Meleerattu musta",en:"Old Black Melerade"},
            '006':{id:'006',classes:[1],classNames:["Mustat"],fi:"Matta musta",en:"Matte Black", oldColor:"Matta"},
            '007':{id:'007',classes:[1],classNames:["Mustat"],fi:"Kiiltävä musta",en:"Glossy Black"},
            '008':{id:'008',classes:[1],classNames:["Mustat"],fi:"Antrasiitti",en:"Antrasite", oldColor:"Anthracite", oldColor2:"Antahracite"},
            '009':{id:'009',classes:[1],classNames:["Mustat"],fi:"Vaalea antrasiitti",en:"Light Antrasite"},
            '010':{id:'010',classes:[1],classNames:["Mustat"],fi:"Tumma antrasiitti",en:"Dark Antrasite"},
            '011':{id:'011',classes:[1],classNames:["Mustat"],fi:"Pehmeä antrasiitti",en:"Soft Antrasite"},
            '012':{id:'012',classes:[1],classNames:["Mustat"],fi:"Meleerattu antrasiitti",en:"Antrasite Melerade", oldColor:"antracit melange"},
            '013':{id:'013',classes:[1],classNames:["Mustat"],fi:"Urbaani musta",en:"Urban Black"},
            
            '014':{id:'014',classes:[2],classNames:["Valkoiset"],fi:"Valkoinen",en:"White", oldColor:"valk.", oldColor2:"Valkonen"},
            '015':{id:'015',classes:[2],classNames:["Valkoiset"],fi:"Meleerattu valkoinen",en:"White Melerade"},
            '016':{id:'016',classes:[2],classNames:["Valkoiset"],fi:"Pehmeä valkoinen",en:"Soft Melerade"},
            '017':{id:'017',classes:[2],classNames:["Valkoiset"],fi:"Luonnonvalkoinen",en:"Natural White",oldColor:"luonnon valkoinen"},
            '018':{id:'018',classes:[2],classNames:["Valkoiset"],fi:"Luonnollinen",en:"Natural"},
            '019':{id:'019',classes:[2],classNames:["Valkoiset"],fi:"Pellava",en:"Linen"},
            '020':{id:'020',classes:[2],classNames:["Valkoiset"],fi:"Vaalea khaki",en:"Light Khaki"},
            '021':{id:'021',classes:[2],classNames:["Valkoiset"],fi:"Tumman khaki",en:"Dark Khaki"},
            '022':{id:'022',classes:[2],classNames:["Valkoiset"],fi:"Meleerattu khaki",en:"Khaki Melerade"},
            '023':{id:'023',classes:[2],classNames:["Valkoiset"],fi:"Kirkas",en:"Clear"},
            '024':{id:'024',classes:[2],classNames:["Valkoiset"],fi:"Läpinäkyvä",en:"Transparent"},
            '025':{id:'025',classes:[2],classNames:["Valkoiset"],fi:"Jää",en:"Ice"},
            '026':{id:'026',classes:[2],classNames:["Valkoiset"],fi:"Hopea",en:"Silver"},
            '027':{id:'027',classes:[2],classNames:["Valkoiset"],fi:"Satiinin Hopea",en:"Satin silver"},
            '028':{id:'028',classes:[2],classNames:["Valkoiset"],fi:"Hiekka",en:"Sand"},
            '029':{id:'029',classes:[2],classNames:["Valkoiset"],fi:"Vanukas",en:"Custard"},
            
            '030':{id:'030',classes:[3],classNames:["Harmaat"],fi:"Harmaa",en:"Grey"},
            '031':{id:'031',classes:[3],classNames:["Harmaat"],fi:"Vaalean harmaa",en:"Light Grey", oldColor:"vaaleanharmaa"},
            '032':{id:'032',classes:[3],classNames:["Harmaat"],fi:"Tumman harmaa",en:"Dark Grey", oldColor:"tummanharmaa"},
            '033':{id:'033',classes:[3],classNames:["Harmaat"],fi:"Kirkkaan harmaa",en:"Bright Grey"},
            '034':{id:'034',classes:[3],classNames:["Harmaat"],fi:"Meleerattu harmaa",en:"Grey Melerade", oldColor:"Vaaleanharmaa melange", oldColor2:"Harmaa Melange"},
            '035':{id:'035',classes:[3],classNames:["Harmaat"],fi:"Sporttinen harmaa",en:"Sport Grey"},
            '036':{id:'036',classes:[3],classNames:["Harmaat"],fi:"Pehmeä harmaa",en:"Soft Grey"},
            '037':{id:'037',classes:[3],classNames:["Harmaat"],fi:"Teräs",en:"Steel"},
            '038':{id:'038',classes:[3],classNames:["Harmaat"],fi:"Harjattu teräs",en:"Brushed Steel"},
            '039':{id:'039',classes:[3],classNames:["Harmaat"],fi:"Aseen teräs",en:"Gun metal",oldColor:"Gun Metail", oldColor2:"Gunmetal"},
            '040':{id:'040',classes:[3],classNames:["Harmaat"],fi:"Grafiitti",en:"Graphite"},
            '041':{id:'041',classes:[3],classNames:["Harmaat"],fi:"Tuhka",en:"Ash"},
            
            '042':{id:'042',classes:[4],classNames:["Punaiset"],fi:"Punainen",en:"Red", oldColor:"pun", oldColor2:"Punainen kierrtäyskolmio"},
            '043':{id:'043',classes:[4],classNames:["Punaiset"],fi:"Vaaleanpunainen",en:"Light Red", oldColor:"Vaal.punainen", oldColor2:"Vaalenpunainen"},
            '044':{id:'044',classes:[4],classNames:["Punaiset"],fi:"Tummanpunainen",en:"Dark Red", oldColor:"Tummanpunanen", oldColor2:"Tummemman punainen"},
            '045':{id:'045',classes:[4],classNames:["Punaiset"],fi:"Kirkkaan punainen",en:"Bright Red"},
            '046':{id:'046',classes:[4],classNames:["Punaiset"],fi:"Huomioväri",en:"Red Signal Colour"},
            '047':{id:'047',classes:[4],classNames:["Punaiset"],fi:"Heijastava punainen",en:"Reflective Red"},
            '048':{id:'048',classes:[4],classNames:["Punaiset"],fi:"Meleerattu punainen",en:"Red Melerade"},
            '049':{id:'049',classes:[4],classNames:["Punaiset"],fi:"Pehmeä punainen",en:"Soft Red"},
            '050':{id:'050',classes:[4],classNames:["Punaiset"],fi:"Syvän punainen",en:"Deep Red"},
            '051':{id:'051',classes:[4],classNames:["Punaiset"],fi:"Tulen punainen",en:"Fire Red"},
            '052':{id:'052',classes:[4],classNames:["Punaiset"],fi:"Viinin punainen",en:"Wine", oldColor:"Viininpunainen",oldColor2:"Wine Red"},
            '053':{id:'053',classes:[4],classNames:["Punaiset"],fi:"Mansikka",en:"Strawberry", oldColor:"Mansikanpunainen"},
            '054':{id:'054',classes:[4],classNames:["Punaiset"],fi:"Kirsikka",en:"Cerise"},
            '055':{id:'055',classes:[4],classNames:["Punaiset"],fi:"Toffeeomena",en:"Candy Apple"},
            '056':{id:'056',classes:[4],classNames:["Punaiset"],fi:"Koralli",en:"Coral"},
            '057':{id:'057',classes:[4],classNames:["Punaiset"],fi:"Magenta",en:"Magenta", oldColor:"Magneta"},
            '058':{id:'058',classes:[4],classNames:["Punaiset"],fi:"Fuksia",en:"Fuchsia"},
            '059':{id:'059',classes:[4],classNames:["Punaiset"],fi:"Burgundi",en:"Burgundy", oldColor:"burgundinpunainen"},
            '060':{id:'060',classes:[4],classNames:["Punaiset"],fi:"Pinkki",en:"Pink", },
            '061':{id:'061',classes:[4],classNames:["Punaiset"],fi:"Vaalean pinkki",en:"Light Pink"},
            '062':{id:'062',classes:[4],classNames:["Punaiset"],fi:"Tumman pinkki",en:"Dark Pink", oldColor:"tumma pinkki"},
            '063':{id:'063',classes:[4],classNames:["Punaiset"],fi:"Kirkkaan pinkki",en:"Bright Pink"},
            '064':{id:'064',classes:[4],classNames:["Punaiset"],fi:"Huomioväri pinkki",en:"Pink Signal Colour"},
            '065':{id:'065',classes:[4],classNames:["Punaiset"],fi:"Heijastava pinkki",en:"Reflective Pink"},
            '066':{id:'066',classes:[4],classNames:["Punaiset"],fi:"Meleerattu pinkki",en:"Pink Melerade"},
            '067':{id:'067',classes:[4],classNames:["Punaiset"],fi:"Pehmeä pinkki",en:"Soft Pink"},
            '068':{id:'068',classes:[4],classNames:["Punaiset"],fi:"Ruusun pinkki",en:"Rose",oldColor:"rosa"},
            '069':{id:'069',classes:[4],classNames:["Punaiset"],fi:"Puuteriroosa",en:"Powder Pink"},
            '070':{id:'070',classes:[4],classNames:["Punaiset"],fi:"Räikeän pinkki",en:"Hot Pink"},
            '071':{id:'071',classes:[4],classNames:["Punaiset"],fi:"Vauvan pinkki",en:"Baby Pink"},
            '072':{id:'072',classes:[4],classNames:["Punaiset"],fi:"Millenial pinkki",en:"Millenial Pink"},
            '073':{id:'073',classes:[4],classNames:["Punaiset"],fi:"Hattara",en:"Cotton Candy"},
            
            '074':{id:'074',classes:[5],classNames:["Keltaiset"],fi:"Keltainen",en:"Yellow"},
            '075':{id:'075',classes:[5],classNames:["Keltaiset"],fi:"Vaalean keltainen",en:"Light Yellow"},
            '076':{id:'076',classes:[5],classNames:["Keltaiset"],fi:"Tumman keltainen",en:"Dark Yellow"},
            '077':{id:'077',classes:[5],classNames:["Keltaiset"],fi:"Kirkkaan keltainen",en:"Bright Yellow"},
            '078':{id:'078',classes:[5],classNames:["Keltaiset"],fi:"Huomioväri keltainen",en:"Yellow Signal Colour"},
            '079':{id:'079',classes:[5],classNames:["Keltaiset"],fi:"Heijastava keltainen",en:"Reflective Yellow"},
            '080':{id:'080',classes:[5],classNames:["Keltaiset"],fi:"Meleerattu keltainen",en:"Yellow Melerade"},
            '081':{id:'081',classes:[5],classNames:["Keltaiset"],fi:"Pehmeä keltainen",en:"Soft Yellow"},
            '082':{id:'082',classes:[5],classNames:["Keltaiset"],fi:"Aurinko",en:"Solar Yellow"},
            '083':{id:'083',classes:[5],classNames:["Keltaiset"],fi:"Sitruuna",en:"Lemon"},
            '084':{id:'084',classes:[5],classNames:["Keltaiset"],fi:"Kulta",en:"Gold"},
            '085':{id:'085',classes:[5],classNames:["Keltaiset"],fi:"Messinki",en:"Brass"},
            
            '086':{id:'086',classes:[6],classNames:["Oranssit"],fi:"Oranssi",en:"Orange", oldColor:"orange hc/af"},
            '087':{id:'087',classes:[6],classNames:["Oranssit"],fi:"Vaalean oranssi",en:"Light Orange"},
            '088':{id:'088',classes:[6],classNames:["Oranssit"],fi:"Tumman oranssi",en:"Dark Orange"},
            '089':{id:'089',classes:[6],classNames:["Oranssit"],fi:"Kirkkaan oranssi",en:"Bright Orange"},
            '090':{id:'090',classes:[6],classNames:["Oranssit"],fi:"Huomioväri oranssi",en:"Orange Signal Colour"},
            '091':{id:'091',classes:[6],classNames:["Oranssit"],fi:"Heijastava oranssi",en:"Reflective Orange"},
            '092':{id:'092',classes:[6],classNames:["Oranssit"],fi:"Meleerattu oranssi",en:"Orange Melerad"},
            '093':{id:'093',classes:[6],classNames:["Oranssit"],fi:"Pehmeä Oranssi",en:"Soft Orange"},
            '094':{id:'094',classes:[6],classNames:["Oranssit"],fi:"Kurpitsa",en:"Pumpkin"},
            '095':{id:'095',classes:[6],classNames:["Oranssit"],fi:"Aprikoosi",en:"Apricot"},
            '096':{id:'096',classes:[6],classNames:["Oranssit"],fi:"Pronssi",en:"Bronze"},
            
            '097':{id:'097',classes:[7],classNames:["Vihreät"],fi:"Vihreä",en:"Green"},
            '098':{id:'098',classes:[7],classNames:["Vihreät"],fi:"Vaalean vihreä",en:"Light Green", oldColor:"Vaaleanvihreä"},
            '099':{id:'099',classes:[7],classNames:["Vihreät"],fi:"Tumman vihreä",en:"Dark Green", oldColor:"Tummanvihreä"},
            '100':{id:'100',classes:[7],classNames:["Vihreät"],fi:"Kirkkaan vihreä",en:"Bright Green"},
            '101':{id:'101',classes:[7],classNames:["Vihreät"],fi:"Heijastava vihreä",en:"Reflective Green"},
            '102':{id:'102',classes:[7],classNames:["Vihreät"],fi:"Meleerattu vihreä",en:"Green Melerade"},
            '103':{id:'103',classes:[7],classNames:["Vihreät"],fi:"Pehmeä vihreä",en:"Soft Green"},
            '104':{id:'104',classes:[7],classNames:["Vihreät"],fi:"Armeijan vihreä",en:"Army Green"},
            '105':{id:'105',classes:[7],classNames:["Vihreät"],fi:"Urbaani khaki",en:"Urban Khaki"},
            '106':{id:'106',classes:[7],classNames:["Vihreät"],fi:"Smaragdi",en:"Emerald", oldColor2:"Kelly green"},
            '107':{id:'107',classes:[7],classNames:["Vihreät"],fi:"Omenan vihreä",en:"Apple Green"},
            '108':{id:'108',classes:[7],classNames:["Vihreät"],fi:"Orkidean vihreä",en:"Orchid Green"},
            '109':{id:'109',classes:[7],classNames:["Vihreät"],fi:"Aavikko",en:"Desert"},
            '110':{id:'110',classes:[7],classNames:["Vihreät"],fi:"Pensaikko",en:"Bush"},
            '111':{id:'111',classes:[7],classNames:["Vihreät"],fi:"Metsä",en:"Forest"},
            '112':{id:'112',classes:[7],classNames:["Vihreät"],fi:"Tumma metsä",en:"Wood"},
            '113':{id:'113',classes:[7],classNames:["Vihreät"],fi:"Havu",en:"Pine"},
            '114':{id:'114',classes:[7],classNames:["Vihreät"],fi:"Apila",en:"Shamrock"},
            '115':{id:'115',classes:[7],classNames:["Vihreät"],fi:"Pistaasi",en:"Pistachio"},
            '116':{id:'116',classes:[7],classNames:["Vihreät"],fi:"Oliivi",en:"Olive"},
            '117':{id:'117',classes:[7],classNames:["Vihreät"],fi:"Lime",en:"Lime",oldColor:"Limetinvihreä"},
            '118':{id:'118',classes:[7],classNames:["Vihreät"],fi:"Pullon vihreä",en:"Bottle Green"},
            
            '120':{id:'120',classes:[8],classNames:["Siniset"],fi:"Sininen",en:"Blue"},
            '121':{id:'121',classes:[8],classNames:["Siniset"],fi:"Vaaleansininen",en:"Light Blue",oldColor:"vaalean sininen"},
            '122':{id:'122',classes:[8],classNames:["Siniset"],fi:"Tummansininen",en:"Dark Blue", oldColor:"t.sin", oldColor2:"T.sininen", oldColor3:"tumman sininen"},
            '123':{id:'123',classes:[8],classNames:["Siniset"],fi:"Kirkkaan sininen",en:"Bright Blue"},
            '124':{id:'124',classes:[8],classNames:["Siniset"],fi:"Heijastava sininen",en:"Reflective Blue"},
            '125':{id:'125',classes:[8],classNames:["Siniset"],fi:"Keskisininen",en:"Medium Blue"},
            '126':{id:'126',classes:[8],classNames:["Siniset"],fi:"Meleerattu sininen",en:"Blue Melerade"},
            '127':{id:'127',classes:[8],classNames:["Siniset"],fi:"Pehmeä sininen",en:"Soft Blue"},
            '128':{id:'128',classes:[8],classNames:["Siniset"],fi:"Keskiyön sininen",en:"Midnight Blue"},
            '129':{id:'129',classes:[8],classNames:["Siniset"],fi:"Vauvan vaaleansininen",en:"Baby Blue"},
            '130':{id:'130',classes:[8],classNames:["Siniset"],fi:"Aito sininen",en:"Royal Blue", oldColor:"Royal", oldColor2:"Royal Sininen", oldColor3:"Royalsininen"},
            '131':{id:'131',classes:[8],classNames:["Siniset"],fi:"Syvänsinen",en:"Deep Blue"},
            '132':{id:'132',classes:[8],classNames:["Siniset"],fi:"Sähkönsininen",en:"Electric Blue"},
            '133':{id:'133',classes:[8],classNames:["Siniset"],fi:"Laivastonsininen",en:"Navy Blue", oldColor:"Navy",oldColor2:"2Navy", oldColor3:"navy sininen"},
            '134':{id:'134',classes:[8],classNames:["Siniset"],fi:"Kevyen laivastonsininen",en:"Light Navy"},
            '135':{id:'135',classes:[8],classNames:["Siniset"],fi:"Tumma laivastonsininen",en:"Dark Navy"},
            '136':{id:'136',classes:[8],classNames:["Siniset"],fi:"Kirkkaan laivastonsininen",en:"Bright Navy"},
            '137':{id:'137',classes:[8],classNames:["Siniset"],fi:"Pehmeä laivastonsininen",en:"Soft Navy"},
            '138':{id:'138',classes:[8],classNames:["Siniset"],fi:"Taivaansininen",en:"Sky Blue", oldColor2:"Taivaan Sininen"},
            '139':{id:'139',classes:[8],classNames:["Siniset"],fi:"Tumma denim",en:"Dark Denim / Denim"},
            '140':{id:'140',classes:[8],classNames:["Siniset"],fi:"Vaalea denim",en:"Light Denim / Denim"},
            '141':{id:'141',classes:[8],classNames:["Siniset"],fi:"Meleerattu denim",en:"Denim Melerade / Denim"},
            '142':{id:'142',classes:[8],classNames:["Siniset"],fi:"Azure",en:"Azure", oldColor:'Azure Blue'},
            '143':{id:'143',classes:[8],classNames:["Siniset"],fi:"Atoll",en:"Atoll", oldColor:"Atollin sininen"},
            '144':{id:'144',classes:[8],classNames:["Siniset"],fi:"Aqua",en:"Aqua"},
            '145':{id:'145',classes:[8],classNames:["Siniset"],fi:"Valtameri",en:"Ocean", oldColor:"Sininen/Meri"},
            '146':{id:'146',classes:[8],classNames:["Siniset"],fi:"Vaalean sinivihreä",en:"Light Bluegreen"},
            '147':{id:'147',classes:[8],classNames:["Siniset"],fi:"Tumman sinivihreä",en:"Dark Bluegreen"},
            '148':{id:'148',classes:[8],classNames:["Siniset"],fi:"Pehmeä sinivihreä",en:"Soft Bluegreen"},
            '149':{id:'149',classes:[8],classNames:["Siniset"],fi:"Diva",en:"Diva Blue"},
            '150':{id:'150',classes:[8],classNames:["Siniset"],fi:"Turkoosi",en:"Turquoise"},
            '151':{id:'151',classes:[8],classNames:["Siniset"],fi:"Vaalea turkoosi",en:"Light Turquoise"},
            '152':{id:'152',classes:[8],classNames:["Siniset"],fi:"Tumma turkoosi",en:"Dark Turquoise"},
            '153':{id:'153',classes:[8],classNames:["Siniset"],fi:"Kirkkaan turkoosi",en:"Bright Turquoise"},
            '154':{id:'154',classes:[8],classNames:["Siniset"],fi:"Meleerattu turkoosi",en:"Turquoise Melerade"},
            '155':{id:'155',classes:[8],classNames:["Siniset"],fi:"Pehmeä turkoosi",en:"Soft Turquoise"},
            '156':{id:'156',classes:[8],classNames:["Siniset"],fi:"Huomioväri turkoosi",en:"Turquoise Signal Colour"},
            '157':{id:'157',classes:[8],classNames:["Siniset"],fi:"Heijastava turkoosi",en:"Reflective Turquoise"},
            '158':{id:'158',classes:[8],classNames:["Siniset"],fi:"Aito turkoosi",en:"Real Turquoise"},
            
            '159':{id:'159',classes:[9],classNames:["Violetit"],fi:"Violetti",en:"Violet"},
            '160':{id:'160',classes:[9],classNames:["Violetit"],fi:"Vaalean violetti",en:"Light Violet"},
            '161':{id:'161',classes:[9],classNames:["Violetit"],fi:"Tumman violetti",en:"Dark Violet"},
            '162':{id:'162',classes:[9],classNames:["Violetit"],fi:"Kirkkaan violetti",en:"Bright Violet"},
            '163':{id:'163',classes:[9],classNames:["Violetit"],fi:"Meleerattu violetti",en:"Violet Melerade"},
            '164':{id:'164',classes:[9],classNames:["Violetit"],fi:"Pehmeä violetti",en:"Soft Violet"},
            '165':{id:'165',classes:[9],classNames:["Violetit"],fi:"Huomioväri violetti",en:"Violet Signal Colour"},
            '166':{id:'166',classes:[9],classNames:["Violetit"],fi:"Heijastava violetti",en:"Reflective Violet"},
            '167':{id:'167',classes:[9],classNames:["Violetit"],fi:"Urbaani violetti",en:"Urban Purple"},
            '168':{id:'168',classes:[9],classNames:["Violetit"],fi:"Säteilevä violetti",en:"Radiant Purple"},
            '169':{id:'169',classes:[9],classNames:["Violetit"],fi:"Laventeli",en:"Lavender"},
            '170':{id:'170',classes:[9],classNames:["Violetit"],fi:"Lila",en:"Purple"},
            '171':{id:'171',classes:[9],classNames:["Violetit"],fi:"Vaalea lila",en:"Light Purple"},
            '172':{id:'172',classes:[9],classNames:["Violetit"],fi:"Tumma lila",en:"Dark Purple"},
            '173':{id:'173',classes:[9],classNames:["Violetit"],fi:"Kirkas lila",en:"Bright Purple"},
            '174':{id:'174',classes:[9],classNames:["Violetit"],fi:"Meleerattu lila",en:"Purple Melerade"},
            '175':{id:'175',classes:[9],classNames:["Violetit"],fi:"Pehemeä lila",en:"Soft Purple"},
            '176':{id:'176',classes:[9],classNames:["Violetit"],fi:"Huomioväri lila",en:"Purple Signal Colour"},
            '177':{id:'177',classes:[9],classNames:["Violetit"],fi:"Heijastava lila",en:"Reflective Purple"},
            '178':{id:'178',classes:[9],classNames:["Violetit"],fi:"Syreeni",en:"Lilac"},
            
            '179':{id:'179',classes:[10],classNames:["Ruskeat"],fi:"Ruskea",en:"Brown"},
            '180':{id:'180',classes:[10],classNames:["Ruskeat"],fi:"Vaalean ruskea",en:"Light Brown"},
            '181':{id:'181',classes:[10],classNames:["Ruskeat"],fi:"Tumman ruskea",en:"Dark Brown"},
            '182':{id:'182',classes:[10],classNames:["Ruskeat"],fi:"Kirkkaan ruskea",en:"Bright Brown"},
            '183':{id:'183',classes:[10],classNames:["Ruskeat"],fi:"Meleerattu ruskea",en:"Brown Melerade"},
            '184':{id:'184',classes:[10],classNames:["Ruskeat"],fi:"Pehmea ruskea",en:"Soft Brown"},
            '185':{id:'185',classes:[10],classNames:["Ruskeat"],fi:"Karhun ruskea",en:"Bear Brown"},
            '186':{id:'186',classes:[10],classNames:["Ruskeat"],fi:"Suklaa",en:"Chocolate"},
            '187':{id:'187',classes:[10],classNames:["Ruskeat"],fi:"Kupari",en:"Copper"},
            '188':{id:'188',classes:[10],classNames:["Ruskeat"],fi:"Koivu",en:"Birch"},
            '189':{id:'189',classes:[10],classNames:["Ruskeat"],fi:"Tammi",en:"Oak"},
            '190':{id:'190',classes:[10],classNames:["Ruskeat"],fi:"Vaahtera",en:"Maple"},
            '191':{id:'191',classes:[10],classNames:["Ruskeat"],fi:"Ruusupuu",en:"Rosewood"},
            '192':{id:'192',classes:[10],classNames:["Ruskeat"],fi:"Mahonki",en:"Mahogany"},
            '193':{id:'193',classes:[10],classNames:["Ruskeat"],fi:"Akaasia",en:"Acacia"},
            '194':{id:'194',classes:[10],classNames:["Ruskeat"],fi:"Mänty",en:"Pine"},
            '195':{id:'195',classes:[10],classNames:["Ruskeat"],fi:"Kuusi",en:"Spruce"},

            '196':{id:'196',classes:[3],classNames:["Harmaat"],fi:"Tyynen harmaa",en:"Pacific Grey"},
            '197':{id:'197',classes:[4],classNames:["Punaiset"],fi:"Kardinaalinpunainen",en:"Cardinal Red"},
            '198':{id:'198',classes:[4],classNames:["Punaiset"],fi:"Punaruskea",en:"Maroon"},
            '199':{id:'199',classes:[7],classNames:["Vihreät"],fi:"Pikseli lime",en:"Pixel Lime"},
            '200':{id:'200',classes:[7],classNames:["Vihreät"],fi:"Huomioväri vihreä",en:"Safety Green"},
            '201':{id:'201',classes:[7],classNames:["Vihreät"],fi:"Metsän vihreä",en:"Forest Green"},
            '202':{id:'202',classes:[7],classNames:["Vihreät"],fi:"Irlannnin vihreä",en:"Irish Green"},
            '203':{id:'203',classes:[8],classNames:["Siniset"],fi:"Carolina sininen",en:"Carolina Blue"},
            '204':{id:'204',classes:[8],classNames:["Siniset"],fi:"Syvän laivastonsininen",en:"Deep Navy", oldColor:"2Deep Navy"},
            
            '205':{id:'205',classes:[2],classNames:["Valkoiset"],fi:"Valkea",en:"White", oldColor:"3valkea", oldColor2:"valkea"},
            '206':{id:'206',classes:[11],classNames:["Muut"],fi:"5 neonväriä",en:"5 neon colors", },
            '207':{id:'207',classes:[3],classNames:["Harmaat"],fi:"Harmaa antrasiitti",en:"Grey Antrasite",oldColor:"Anthracite Grey"},
            '208':{id:'208',classes:[3],classNames:["Harmaat"],fi:"Musta antrasiitti",en:"Black Antrasite ", oldColor:"black-antracite"},
            '209':{id:'209',classes:[7],classNames:["Vihreät"],fi:"Basilika",en:"Basil"},
            '210':{id:'210',classes:[10],classNames:["Ruskeat"],fi:"Beige",en:"Beige"},
            '211':{id:'211',classes:[10],classNames:["Ruskeat"],fi:"Beige/Natural",en:"Beige/Natural"},
            '212':{id:'212',classes:[10,1],classNames:["Harmaat","Mustat"],fi:"Musta/Harmaa",en:"Black/Grey"},
            '213':{id:'213',classes:[1,2],classNames:["Valkoiset","Mustat"],fi:"Musta/Valkoinen",en:"Black/White",oldColor:"musta tai valkoinen", oldColor2:"White-Black", oldColor3:"Black-White" },
            '214':{id:'214',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Sininen/Hopea",en:"Blue/Silver"},
            '215':{id:'215',classes:[4,1],classNames:["Punaiset","Mustat"],fi:"Musta/Fuchsia",en:"Black/Fuchsia", oldColor:"Black-Fuchisia"},
            '216':{id:'216',classes:[5,1],classNames:["Keltaiset","Mustat"],fi:"Musta/Lime",en:"Black/Lime", oldColor:"Black-Lime"},
            '217':{id:'217',classes:[1,6],classNames:["Oranssit","Mustat"],fi:"Musta/Oranssi",en:"Black/Orange", oldColor:"Black-Orange"},
            '218':{id:'218',classes:[1,2],classNames:["Valkoiset","Mustat"],fi:"Musta/Hopea",en:"Black/Silver", oldColor:"Black-Silver",oldColor2:"Black/Silver"},
            '219':{id:'219',classes:[8,1],classNames:["Siniset","Mustat"],fi:"Musta/Sininen",en:"Black/Blue", oldColor:"Black-Surf Blue"},
            '220':{id:'220',classes:[1],classNames:["Mustat"],fi:"Musta/Hiili",en:"Black/Charcoal", oldColor:"Black/charcoal"},
            '221':{id:'221',classes:[8,1],classNames:["Siniset","Mustat"],fi:"Musta/Aito sininen",en:"Black/Royal Blue", oldColor:"Black/Royal"},
            '223':{id:'223',classes:[7,2],classNames:["Vihreät","Valkoiset"],fi:"Pullon vihreä/Valkoinen",en:"Bottle Green/White", oldColor:"Bottle/White"},
            '224':{id:'224',classes:[4],classNames:["Punaiset"],fi:"Tiilen punainen",en:"Brick Red"},
            '225':{id:'225',classes:[8],classNames:["Siniset"],fi:"Vaalean aito sininen",en:"Bright Royal Blue", oldColor:"Bright Royal"},
            '226':{id:'226',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Vaalean aito sininen/Valkoinen",en:"Bright Royal Blue/White", oldColor:"Bright Royal-White"},
            '227':{id:'227',classes:[4,1],classNames:["Punaiset","Mustat"],fi:"Burgundy/Musta",en:"Burgundy/Black", oldColor:"Burgundy-Black"},
            '228':{id:'228',classes:[8],classNames:["Siniset"],fi:"Karibian sininen",en:"Caribian Blue", oldColor:"caribic-blue"},
            '229':{id:'229',classes:[2],classNames:["Valkoiset"],fi:"Samppanja",en:"Champagne"},
            '230':{id:'230',classes:[1],classNames:["Mustat"],fi:"Hiili",en:"Charcoal"},
            '231':{id:'231',classes:[1,2],classNames:["Mustat","Valkoiset"],fi:"Hiili/Valkoinen",en:"Charcoal/White"},
            '232':{id:'232',classes:[3],classNames:["Harmaat"],fi:"Kromi",en:"Chrome"},
            '233':{id:'233',classes:[5],classNames:["Keltaiset"],fi:"Klassinen oliivi",en:"Classic Olive"},
            '234':{id:'234',classes:[4],classNames:["Punaiset"],fi:"Klassinen punainen",en:"Classic Red", oldColor:"classic red"},
            '235':{id:'235',classes:[4,2],classNames:["Punaiset","Valkoiset"],fi:"Klassinen punainen/Valkoinen",en:"Classic Red/White", oldColor:"Classic Red-White"},
            '236':{id:'236',classes:[8],classNames:["Siniset"],fi:"Kobaltin sininen",en:"Cobalt Blue", oldColor:"cobalt blue", oldColor2:"koboltinsininen"},
            '237':{id:'237',classes:[5],classNames:["Keltaiset"],fi:"Kerma",en:"Cream"},
            '238':{id:'238',classes:[11],classNames:["Muut"],fi:"Kustomi",en:"Custom", oldColor:"custom"},
            '239':{id:'239',classes:[7,8],classNames:["Siniset","Vihreät"],fi:"Syaani",en:"Cyan",oldColor:"Syaani"},
            '240':{id:'240',classes:[3],classNames:["Harmaat"],fi:"Tumman kanervan harmaa",en:"Dark Heather Grey"},
            '241':{id:'241',classes:[11],classNames:["Muut"],fi:"Syvä meleerattu",en:"Deep Melange"},
            '242':{id:'242',classes:[5],classNames:["Keltaiset"],fi:"Pitaija",en:"Dragon Fruit"},
            '243':{id:'243',classes:[5],classNames:["Keltaiset"],fi:"Sähköinen keltainen",en:"Electric Yellow"},
            '245':{id:'245',classes:[4],classNames:["Punaiset"],fi:"Flamingo",en:"Flamingo"},
            '246':{id:'246',classes:[11],classNames:["Muut"],fi:"Florange",en:"Flourange"},
            '247':{id:'247',classes:[5],classNames:["Keltaiset"],fi:"Fluoresentti keltainen",en:"Fluorescent Yellow"},
            '248':{id:'248',classes:[8],classNames:["Siniset"],fi:"Ranskan laivastonsininen",en:"French Navy"},
            '249':{id:'249',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Ranskan laivastonsininen/Valkoinen",en:"French Navy/White",oldColor:"French Navy-White"},
            '250':{id:'250',classes:[3],classNames:["Harmaat"],fi:"Grafiitin harmaa",en:"Graphite Grey"},
            '251':{id:'251',classes:[3,1],classNames:["Harmaat","Mustat"],fi:"Grafiitin harmaa/Musta",en:"Graphite Grey/Black", oldColor:"Graphite Grey-Black"},
            '252':{id:'252',classes:[7],classNames:["Vihreät"],fi:"Vihreä/Hopea",en:"Green/Silver"},
            '256':{id:'256',classes:[3],classNames:["Harmaat"],fi:"Harmaa/Aseen metalli",en:"Grey/Gun Metal", oldColor:"Harmaa/Gunmetal"},
            '257':{id:'257',classes:[3,1],classNames:["Harmaat","Mustat"],fi:"Harmaa/Musta",en:"Grey/Black", oldColor:"harmaa/musta"},
            '258':{id:'258',classes:[3],classNames:["Harmaat"],fi:"Kanervan harmaa",en:"Heather Grey"},
            '259':{id:'259',classes:[5],classNames:["Keltaiset"],fi:"Hohtavan keltainen",en:"Fluorescent Yellow",oldColor:"hohtavankeltainen"},
            '260':{id:'260',classes:[6],classNames:["Oranssit"],fi:"Hohtavan oranssi",en:"Fluorescent Orange",oldColor:"hohtavanoranssi"},
            '261':{id:'261',classes:[3],classNames:["Harmaat"],fi:"Hopea/Kiiltävä",en:"Silver/Glossy",oldColor:"Hopea, kiiltävä"},
            '262':{id:'262',classes:[3],classNames:["Harmaat"],fi:"Hopea/Hopea",en:"Silver/Silver",oldColor:"hopea/hopea"},
            '263':{id:'263',classes:[2,1],classNames:["Valkoiset","Mustat"],fi:"Hopea/Musta",en:"Silver/Black",oldColor:"Hopea/musta", oldColor2:"Musta/Hopea"},
            '264':{id:'264',classes:[2,4],classNames:["Valkoiset","Punaiset"],fi:"Hopea/Punainen",en:"Silver/Red",oldColor:"hopea/punainen"},
            '265':{id:'265',classes:[2,8],classNames:["Valkoiset","Siniset"],fi:"Hopea/Sininen",en:"Silver/Blue",oldColor:"hopea/sininen"},
            '266':{id:'266',classes:[5],classNames:["Keltaiset"],fi:"Signal Color Yellow",en:"Huomio keltainen",oldColor:"Huomio keltainen"},
            '267':{id:'267',classes:[6],classNames:["Oranssit"],fi:"Signal Color Orange",en:"Huomio oranssi",oldColor:"huomio-oranssi"},
            '268':{id:'268',classes:[7],classNames:["Vihreät"],fi:"Huomio vihreä",en:"Signal Color Green",oldColor:"Huomiovihreä"},
            '269':{id:'269',classes:[4],classNames:["Punaiset"],fi:"Joulun punainen",en:"Christmas Red",oldColor:"Joulun punainen"},
            '270':{id:'270',classes:[5,1],classNames:["Keltaiset","Mustat"],fi:"Keltainen/Musta",en:"Yellow/Black",oldColor:"Kelta/Musta"},
            '271':{id:'271',classes:[5,8],classNames:["Keltaiset","Siniset"],fi:"Keltainen/Laivastonsininen",en:"Yellow/Navy",oldColor:"Kelta/Navy"},
            '272':{id:'272',classes:[5,4],classNames:["Keltaiset","Punaiset"],fi:"Keltainen/Punainen",en:"Yellow/Red",oldColor:"Kelta/pun"},
            '273':{id:'273',classes:[5,8],classNames:["Keltaiset","Siniset"],fi:"Keltainen/Sininen",en:"Yellow/Blue",oldColor:"kelta/sininen"},
            '275':{id:'275',classes:[5],classNames:["Keltaiset"],fi:"Keltainen/Sitruuna",en:"Yellow/Lemon"},
            '277':{id:'277',classes:[5],classNames:["Keltaiset"],fi:"Kirkas keltainen",en:"Bright Yellow",oldColor:"kirkas keltainen"},
            '278':{id:'278',classes:[6],classNames:["Keltaiset"],fi:"Kirkas oranssi",en:"Bright Orange",oldColor:"Kirkas Oranssi"},
            '279':{id:'279',classes:[7],classNames:["Vihreät"],fi:"Kirkas vihreä",en:"Bright Green",oldColor:"Kirkas vihreä"},
            '280':{id:'280',classes:[5],classNames:["Keltaiset"],fi:"Kirkas/Keltainen",en:"Clear/Yellow",oldColor:"kirkas/keltainen"},
            '281':{id:'281',classes:[1],classNames:["Mustat"],fi:"Kirkas/Musta",en:"Clear/Black",oldColor:"kirkas/musta"},
            '282':{id:'282',classes:[2],classNames:["Valkoiset"],fi:"Kirkas/Valkoinen",en:"Clear/White",oldColor:"kirkas/valkoinen"},
            '285':{id:'285',classes:[1],classNames:["Mustat"],fi:"Kivihiili/Antrasiitti",en:"Coal/Anthracite",oldColor:"kivihiili/tummanharmaa (anthracite)"},
            '286':{id:'286',classes:[10],classNames:["Ruskeat"],fi:"Konjakinruskea",en:"Cognac",oldColor:"Konjakinruskea"},
            '287':{id:'287',classes:[10],classNames:["Ruskeat"],fi:"Korkki",en:"Cork",oldColor:"korkki"},
            '288':{id:'288',classes:[7],classNames:["Vihreät"],fi:"Kromi/Teräs",en:"Chrome/Steel",oldColor:"kromi/teräs"},
            '289':{id:'289',classes:[5],classNames:["Keltaiset"],fi:"Kullan keltainen",en:"Golden Yellow",oldColor:"Kullankeltainen"},
            '290':{id:'290',classes:[5],classNames:["Keltaiset"],fi:"Kulta/Samppanja",en:"Gold/Champagne",oldColor:"Kulta/Champagne"},
            '292':{id:'292',classes:[11],classNames:["Muut"],fi:"Lajitelma",en:"Assortment",oldColor:"lajitelma"},
            '293':{id:'293',classes:[2],classNames:["Valkoiset"],fi:"LED kirkas",en:"LED Clear",oldColor:"led kirkas"},
            '294':{id:'294',classes:[4],classNames:["Punaiset"],fi:"LED punainen",en:"LED Red",oldColor:"led punainen"},
            '295':{id:'295',classes:[1],classNames:["Mustat"],fi:"Vaalea grafiitti",en:"Light Graphite",oldColor:"Light Graphite"},
            '296':{id:'296',classes:[2],classNames:["Valkoiset"],fi:"Vaalean harmaa/Valkoinen",en:"Light Grey/White",oldColor:"Light Grey-White"},
            '297':{id:'297',classes:[8],classNames:["Vihreät"],fi:"Lime/Vihreä",en:"Lime/Green",oldColor:"Lime-green"},
            '298':{id:'298',classes:[2,7],classNames:["Vihreät","Valkoiset"],fi:"Lime/Valkoinen",en:"Lime/White",oldColor:"Lime-White",oldColor2:"Valkoinen/lime"},
            '299':{id:'299',classes:[2,7],classNames:["Vihreät","Valkoiset"],fi:"Lime/Hopea",en:"Lime/Silver",oldColor:"Lime/Silver"},
            '300':{id:'300',classes:[4],classNames:["Punaiset"],fi:"Lohen vaaleanpunainen",en:"Salmon Light Red",oldColor:"lohi vaaleanpunainen"},
            '301':{id:'301',classes:[4],classNames:["Punaiset"],fi:"Meleerattu vaaleanpunainen",en:"Pink Melange",oldColor:"Meleerattu vaaleanpunainen"},
            '302':{id:'302',classes:[8],classNames:["Siniset"],fi:"Meren sininen",en:"Sea Blue",oldColor:"merensininen"},
            '303':{id:'303',classes:[3],classNames:["Harmaat"],fi:"Metalli",en:"Metal",oldColor:"metalli"},
            '304':{id:'304',classes:[1],classNames:["Mustat"],fi:"Metallin musta",en:"Black Metal",oldColor:"Metallic Black"},
            '305':{id:'305',classes:[3],classNames:["Harmaat"],fi:"Metallin harmaa",en:"Grey Metal",oldColor:"Metallinharmaa"},
            '306':{id:'306',classes:[11],classNames:["Muut"],fi:"Moniväri",en:"Multicolor",oldColor:"Moni", oldColor2:"monivärinen", oldColor3:"multi",oldColor4:"Neliväri"},
            '307':{id:'307',classes:[1],classNames:["Mustat"],fi:"Musta/Rasteri",en:"Black/Grid",oldColor:"musta / rasteri"},
            '308':{id:'308',classes:[1,4],classNames:["Mustat","Punaiset"],fi:"Musta-punainen",en:"Black/Red",oldColor:"musta-punainen"},
            '309':{id:'309',classes:[1],classNames:["Mustat"],fi:"Musta/Heijastava",en:"Black/Reflective",oldColor:"Musta-reflective"},
            '310':{id:'310',classes:[1,4,3],classNames:["Mustat","Punainen","Harmaa"],fi:"Musta/Punainen/Harmaa",en:"Black/Red/Grey",oldColor:"musta,pun.harm"},
            '311':{id:'311',classes:[1,8],classNames:["Mustat","Siniset"],fi:"Musta/Aqua sininen",en:"Black/Aqua Blue",oldColor:"Musta/Aqua blue"},
            '313':{id:'313',classes:[1,5],classNames:["Mustat","Keltaiset"],fi:"Musta/Keltainen",en:"Black/Yellow",oldColor:"Musta/keltainen"},
            '314':{id:'314',classes:[1],classNames:["Mustat"],fi:"Musta/Kirkas",en:"Black/Clear",oldColor:"musta/kirkas"},
            '315':{id:'315',classes:[1],classNames:["Mustat"],fi:"Musta/Lila",en:"Black/Violet",oldColor:"Musta/Lila"},
            '317':{id:'317',classes:[1],classNames:["Mustat"],fi:"Musta/Keskisininen",en:"Black/Medium Blue",oldColor:"Musta/Mid blue"},
            '318':{id:'318',classes:[1],classNames:["Mustat"],fi:"Musta/Musta",en:"Black/Black",oldColor:"Musta/Musta"},
            //'319':{id:'319',classes:[1,6],classNames:["Mustat","Oranssit"],fi:"Musta/Oranssi",en:"Black/Orange",oldColor:"musta/oranssi"},
            '320':{id:'320',classes:[1],classNames:["Mustat"],fi:"Musta/Pinkki",en:"Black/Pink",oldColor:"Musta/Pinkki"},
            '321':{id:'321',classes:[1,4],classNames:["Mustat","Punaiset"],fi:"Musta/Punainen",en:"Black/Red",oldColor:"Musta/Pun", oldColor2:"Musta/punainen"},
            '322':{id:'322',classes:[1,4],classNames:["Mustat","Punaiset"],fi:"Musta/Rosa",en:"Black/Rose",oldColor:"Musta/Rosa"},
            '323':{id:'323',classes:[1,10],classNames:["Mustat","Ruskeat"],fi:"Musta/Ruskea",en:"Black/Brown",oldColor:"Musta/Ruskea"},
            '325':{id:'325',classes:[1,7],classNames:["Mustat","Vihreät"],fi:"Musta/Vihreä",en:"Black/Green",oldColor:"Musta/Vihreä", oldColor:"vihreä/musta"},
            '326':{id:'326',classes:[1],classNames:["Mustat"],fi:"Luonnollinen/Musta",en:"Natural/Black",oldColor:"Natural - Black"},
            '327':{id:'327',classes:[8],classNames:["Siniset"],fi:"Meleerattu laivastonsininen",en:"Navy Melange",oldColor:"Navy Melange"},
            '328':{id:'328',classes:[8],classNames:["Siniset"],fi:"Laivastonsininen/Lime",en:"Navy/Lime",oldColor:"Navy-Lime"},
            '329':{id:'329',classes:[8],classNames:["Siniset"],fi:"Laivastonsininen/Aito sininen",en:"Navy/Royal Blue",oldColor:"Navy-Royal",oldColor2:"Navy/royal",oldColor3:"Royal-Navy"},
            '330':{id:'330',classes:[5],classNames:["Keltaiset"],fi:"Laivastonsininen/Keltainen",en:"Navy/Yellow",oldColor:"Navy-Yellow"},
            '331':{id:'331',classes:[2,8],classNames:["Siniset","Valkoiset"],fi:"Laivastonsininen/Valkoinen",en:"Navy/White"},
            '332':{id:'332',classes:[8],classNames:["Siniset"],fi:"Neon sininen",en:"Neon Blue",oldColor:"Neonininen"},
            '333':{id:'333',classes:[5],classNames:["Keltaiset"],fi:"Neon keltainen",en:"Neon Yellow",oldColor:"Neonkeltainen"},
            '334':{id:'334',classes:[8],classNames:["Siniset"],fi:"Meleerattu meren sininen",en:"Ocean Blue Melange",oldColor:"ocean blue melange"},
            '335':{id:'335',classes:[1],classNames:["Mustat"],fi:"Vanha musta",en:"Old Black",oldColor:"Old Black"},
            '336':{id:'336',classes:[8],classNames:["Siniset"],fi:"Vanha laivastonsininen",en:"Old Navy",oldColor:"Old Navy"},
            '337':{id:'337',classes:[4],classNames:["Punaiset"],fi:"Vanha ruusu",en:"Old Rose",oldColor:"Old Rose"},
            '338':{id:'338',classes:[6,2],classNames:["Oranssit","Valkoiset"],fi:"Oranssi/Valkoinen",en:"Orange/White",oldColor:"Orange-White", oldColor2:"Valko/oranssi"},
            '339':{id:'339',classes:[6],classNames:["Oranssit"],fi:"Oranssi/Suojaväritys",en:"Orange/Camo",oldColor:"Oranssi / Camo"},
            '340':{id:'340',classes:[6,8],classNames:["Oranssit","Siniset"],fi:"Oranssi/Sininen",en:"Orange/Blue",oldColor:"oranssi/sininen"},
            '341':{id:'341',classes:[6],classNames:["Oranssit"],fi:"Oranssi/Trooppinen hedelmä",en:"Orange/Tropical Fruit",oldColor:"Oranssi/Trooppinen hedelmä"},
            '342':{id:'342',classes:[6],classNames:["Oranssit"],fi:"Oranssin punainen",en:"Orangey Red",oldColor:"oranssin punainen",oldColor2:"Oranssinpunainen"},
            '343':{id:'343',classes:[7],classNames:["Vihreät"],fi:"Oregano",en:"Oregano",oldColor:"Oregano"},
            '344':{id:'344',classes:[8],classNames:["Siniset"],fi:"Oxford sininen",en:"Oxford Blue",oldColor:"Oxford Blue"},
            '345':{id:'345',classes:[7],classNames:["Vihreät"],fi:"Persilja",en:"Parsley",oldColor:"Persilja"},
            '346':{id:'346',classes:[8],classNames:["Siniset"],fi:"Luumu",en:"Plum",oldColor:"Plum"},
            '347':{id:'347',classes:[4],classNames:["Punaiset"],fi:"Punainen/Burgundy",en:"Red/Burgundy",oldColor:"Punainen/Burgundy"},
            '348':{id:'348',classes:[3,8],classNames:["Punaiset","Harmaat"],fi:"Punainen/Harmaa",en:"Punainen/Grey",oldColor:"Punainen/Harmaa"},
            '349':{id:'349',classes:[4],classNames:["Punaiset"],fi:"Punainen/Makea omena",en:"Red/Sweet Apple",oldColor:"Punainen/Makea Omena"},
            '350':{id:'350',classes:[2],classNames:["Valkoiset"],fi:"Purppura/Valkoinen",en:"Purple/White",oldColor:"purple-white"},
            '351':{id:'351',classes:[4],classNames:["Punaiset"],fi:"Punainen/Hopea",en:"Red/Silver",oldColor:"Red/Silver"},
            '352':{id:'352',classes:[4,2],classNames:["Punaiset","Valkoiset"],fi:"Punainen/Valkoinen",en:"Red/White",oldColor:"valk/pun", oldColor2:"Valko/Punainen",oldColor3:"Valkoinen punaisin osin",oldColor4:"valkoinen/punainen"},
            '353':{id:'353',classes:[8],classNames:["Siniset"],fi:"Aito sininen/Kulta",en:"Royal Blue/Gold",oldColor:"Royal/Gold"},
            '354':{id:'354',classes:[8],classNames:["Siniset","Valkoiset"],fi:"Aito sininen/Valkoinen",en:"Royal Blue/White",oldColor:"Royal/White"},
            '355':{id:'355',classes:[1],classNames:["Mustat"],fi:"Runko musta",en:"Black Body",oldColor:"runko musta"},
            '356':{id:'356',classes:[8],classNames:["Siniset"],fi:"Runko sininen",en:"Blue Body",oldColor:"runko sininen"},
            '357':{id:'357',classes:[4],classNames:["Punaiset"],fi:"Ruusukulta",en:"Rosegold",oldColor:"Ruusukulta"},
            '358':{id:'358',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Safiirin sininen/Valkoinen",en:"Sapphire Blue/White",oldColor:"Sapphire Blue-White"},
            '359':{id:'359',classes:[1],classNames:["Mustat"],fi:"Savunharmaa",en:"Smoke Grey",oldColor:"Savunharmaa"},
            '360':{id:'360',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Sininen/Valkoinen",en:"Blue/White",oldColor:"valkoinen/sininen"},
            '361':{id:'361',classes:[8,1],classNames:["Siniset","Mustat"],fi:"Sininen/Musta",en:"Blue/Black",oldColor:"sini/musta",oldColor2:"sininen/musta"},
            '362':{id:'362',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Sininen/Valkea",en:"Blue/White",oldColor:"sini/valkea",oldColor2:"sin/valkea"},
            '363':{id:'363',classes:[8],classNames:["Siniset"],fi:"Sininen kansi",en:"Blue Cover",oldColor:"Sininen kansi"},
            '364':{id:'364',classes:[8],classNames:["Siniset"],fi:"Sininen kierrätyskolmio",en:"Blue Recycling Triangle",oldColor:"Sininen kierrätyskolmio"},
            '365':{id:'365',classes:[6],classNames:["Oranssit"],fi:"Oranssi kierrätyskolmio",en:"Orange Recycling Triangle",oldColor:"Oranssi kierrätyskolmio"},
            '367':{id:'367',classes:[8,4],classNames:["Punaiset","Siniset"],fi:"Sinipunainen",en:"Reddish Blue",oldColor:"sinipunainen"},
            '368':{id:'368',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Taivaan sininen/Valkoinen",en:"Sky Blue/White",oldColor:"skyblue/white"},
            '369':{id:'369',classes:[3],classNames:["Harmaat"],fi:"Kivi",en:"Stone",oldColor:"Stone"},
            '370':{id:'370',classes:[5],classNames:["Keltaiset"],fi:"Auringonkukka",en:"Sunflower",oldColor:"Sunflower"},
            '371':{id:'371',classes:[5,2],classNames:["Keltaiset","Valkoiset"],fi:"Auringonkukka/Valkoinen",en:"Sunflower/White",oldColor:"sunflower/white"},
            '372':{id:'372',classes:[1],classNames:["Mustat"],fi:"Teräs/Musta",en:"Steel/Black",oldColor:"Teräs, kahva musta"},
            '373':{id:'373',classes:[2,4],classNames:["Valkoiset","Punaiset"],fi:"Aito pinkki/Valkoinen",en:"True Pink/White",oldColor:"True Pink-White"},
            '374':{id:'374',classes:[4],classNames:["Punaiset"],fi:"Tumma pinkki",en:"True Pink/White",oldColor:"tumma pinkki"},
            '375':{id:'375',classes:[3],classNames:["Harmaat"],fi:"Meleerattu tumman harmaa",en:"Dark Grey Melange",oldColor:"Tummanharmaa melange"},
            '376':{id:'376',classes:[8,2],classNames:["Siniset","Valkoiset"],fi:"Tumman sininen/Valkoinen",en:"Dark Blue/White",oldColor:"tummansin/valk",oldColor2:"Valkoinen/tummansininen"},
            '377':{id:'377',classes:[8],classNames:["Siniset"],fi:"Turkoosi kierrätyskolmio",en:"Turquoise Recycling Triangle",oldColor:"Turkoosi kierrätyskolmio"},
            '378':{id:'378',classes:[8],classNames:["Vihreät"],fi:"Urbaani suojaväri",en:"Urban Camo",oldColor:"Urban Camo"},
            '379':{id:'379',classes:[8],classNames:["Valkoiset"],fi:"Vaalean beige",en:"Light Beige",oldColor:"vaaleanbeige"},
            '380':{id:'380',classes:[8],classNames:["Siniset"],fi:"Vaaleansininen/Pinkki",en:"Light Blue/Pink",oldColor:"vaaleansininen + pinkki"},
            '381':{id:'381',classes:[8,4],classNames:["Siniset","Punaiset"],fi:"Vaaleansininen/Lila/Pinkki",en:"Light Blue/Purple/Pink",oldColor:"Vaaleansininen/Lila/Pinkki"},
            '382':{id:'382',classes:[2,8],classNames:["Valkoiset","Siniset"],fi:"Valkea/Tummansininen",en:"White/Dark Blue",oldColor:"valkea/tummansininen"},
            '383':{id:'383',classes:[2,3],classNames:["Valkoiset","Harmaat"],fi:"Valkoinen/Harmaa",en:"White/Dark Blue",oldColor:"Valko-Multi-Harmaa"},
            '384':{id:'384',classes:[2],classNames:["Valkoiset"],fi:"Valkoinen reuna",en:"White Edge",oldColor:"Valkoinen reuna"},
            '385':{id:'385',classes:[2],classNames:["Valkoiset"],fi:"Valkoinen runko",en:"White Body",oldColor:"valkoinen runko"},
            '386':{id:'386',classes:[2],classNames:["Valkoiset"],fi:"Valkoinen/Helmi",en:"White/Pearl",oldColor:"Valkoinen/Pearl"},
            '387':{id:'387',classes:[2],classNames:["Valkoiset"],fi:"Valkoinen/Vanilja",en:"White/Vanilla",oldColor:"Valkoinen/Vanilja"},
            '388':{id:'388',classes:[11],classNames:["Muut"],fi:"Värilajitelma",en:"Assortment",oldColor:"Värilajitelma"},
            '389':{id:'389',classes:[11],classNames:["Muut"],fi:"Värilliset",en:"Colored",oldColor:"Värilliset"},
            '390':{id:'390',classes:[11],classNames:["Muut"],fi:"Värisarja",en:"Set of colors",oldColor:"värisarja"},
            '391':{id:'391',classes:[7],classNames:["Vihreät"],fi:"Vihreä/Antrasiitti",en:"Green/Anthracite",oldColor:"Vihreä-Antrasiitti"},
            '392':{id:'392',classes:[7],classNames:["Vihreät"],fi:"Vihreä/Minttu",en:"Green/Mint",oldColor:"Vihreä/Minttu"},
            '393':{id:'393',classes:[7],classNames:["Vihreät"],fi:"Minttu",en:"Mint"},
            '394':{id:'394',classes:[7],classNames:["Vihreät"],fi:"Vaalea Minttu",en:"Light Mint"},
            '395':{id:'395',classes:[7],classNames:["Vihreät"],fi:"Tumma minttu",en:"Dark Mint"},
            '396':{id:'396',classes:[4],classNames:["Punaiset"],fi:"Aito pinkki",en:"True Pink"},
            '397':{id:'397',classes:[7],classNames:["Vihreät"],fi:"Suojaväri",en:"Camo"},
            '398':{id:'398',classes:[9],classNames:["Violetit"],fi:"Violetti/Laventeli",en:"Violet/Lavender",oldColor:"Violetti/Laventeli"},
            '400':{id:'400',classes:[2],classNames:["Valkoiset"],fi:"Valkoinen/Hopea",en:"White/Silver",oldColor:"White/Silver"},
            '401':{id:'401',classes:[4],classNames:["Punaiset"],fi:"Lohen punainen",en:"Salmon Red"},
            '402':{id:'402',classes:[8],classNames:["Siniset"],fi:"Taivas",en:"Sky",oldColor:"Sky"},
            '403':{id:'403',classes:[4],classNames:["Punaiset"],fi:"Rubiini",en:"Ruby"},
            '404':{id:'404',classes:[8],classNames:["Siniset"],fi:"Safiiri",en:"Saphire"},
            '405':{id:'405',classes:[11],classNames:["Muut"],fi:"Neon",en:"Neon"},
            '406':{id:'406',classes:[4],classNames:["Punaiset"],fi:"Neon pinkki",en:"Neon Pink"},
            '407':{id:'407',classes:[7],classNames:["Vihreät"],fi:"Neon vihreä",en:"Neon Green"},
            '408':{id:'408',classes:[5],classNames:["Keltaiset"],fi:"Konjakki",en:"Cognac"},
            '409':{id:'409',classes:[5],classNames:["Keltaiset"],fi:"Viski",en:"Whiskey"},
            '410':{id:'410',classes:[1],classNames:["Mustat"],fi:"Nahka",en:"Leather"},
            '411':{id:'411',classes:[8],classNames:["Valkoiset"],fi:"Seepra",en:"Zebra"},
            '412':{id:'412',classes:[8],classNames:["Keltaiset"],fi:"Seepia",en:"Seepia"},
            '413':{id:'413',classes:[8],classNames:["Vihreät"],fi:"Rosmariini",en:"Rosemary"},
            '414':{id:'414',classes:[8],classNames:["Vihreät"],fi:"Timjami",en:"Thyme"},
            '415':{id:'415',classes:[8],classNames:["Mustat"],fi:"Pistooli",en:"Pistol"},
            '416':{id:'416',classes:[8],classNames:["Mustat"],fi:"Musta nahka",en:"Black Leather"},
            '417':{id:'417',classes:[8],classNames:["Ruskeat"],fi:"Ruskea nahka",en:"Brown Leather"},
            '418':{id:'418',classes:[8],classNames:["Valkoiset"],fi:"Kookos",en:"Coconut"},
            '419':{id:'419',classes:[8],classNames:["Keltaiset"],fi:"Bambu",en:"Bamboo"},
            '420':{id:'420',classes:[9],classNames:["Violetit"],fi:"Kanerva",en:"Heather"},
            '421':{id:'421',classes:[9],classNames:["Siniset","Valkoiset"],fi:"Valkoinen/Tummansininen",en:"White/Dark Blue"},
            '422':{id:'422',classes:[9],classNames:["Valkoiset","Oranssit"],fi:"Valkoinen/Oranssi",en:"White/Orange"},
            '423':{id:'423',classes:[9],classNames:["Valkoiset","Punaiset"],fi:"Valkoinen/Punainen",en:"White/Red"},
            '424':{id:'424',classes:[9],classNames:["Valkoiset","Siniset"],fi:"Valkoinen/Sininen",en:"White/Blue"},
            '425':{id:'425',classes:[9],classNames:["Valkoiset","Vihreät"],fi:"Valkoinen/Lime",en:"White/Lime"},
            '426':{id:'426',classes:[9],classNames:["Valkoiset","Mustat"],fi:"Valkoinen/Musta",en:"White/Black"},
            '427':{id:'427',classes:[9],classNames:["Valkoiset","Mustat"],fi:"Valkoinen/Tummansininen",en:"White/Dark Blue"},
            '428':{id:'428',classes:[9],classNames:["Valkoiset","Vihreät"],fi:"Valkoinen/Vihreä",en:"White/Green"},
            '429':{id:'429',classes:[9],classNames:["Valkoiset"],fi:"Valkoinen/Valkoinen",en:"White/White"},
            '430':{id:'430',classes:[9],classNames:["Valkoiset","Keltaiset"],fi:"Valkoinen/Keltainen",en:"White/Yellow"},
            '431':{id:'431',classes:[9],classNames:["Valkoiset","Punaiset"],fi:"Valkoinen/Vaaleanpunainen",en:"White/Light Red"},
            '432':{id:'432',classes:[3,10],classNames:["Harmaat","Ruskeat"],fi:"Taupe",en:"Taupe"},
            '433':{id:'433',classes:[10],classNames:["Ruskeat"],fi:"Khaki",en:"Khaki"},
            '434':{id:'434',classes:[4],classNames:["Punaiset"],fi:"Aniliininpunainen",en:"Magenta"},
            '435':{id:'435',classes:[8],classNames:["Siniset"],fi:"Denim",en:"Denim"},
            '436':{id:'436',classes:[6],classNames:["Oranssit"],fi:"Papaija",en:"Papaya"},
            '437':{id:'437',classes:[6],classNames:["Oranssit"],fi:"Persikka",en:"Peach"},
        },
        orderResponsibles: {
            anuToivanane: {name:"Anu", id:"anuToivanen"},
            kirsiIkonen: {name:"Kirsi", id:"kirsiIkonen"},
            susannaHartikainen: {name:"Susanna", id:"susannaHartikainen"}
        },
        /* 
        Siirtokuvapainatus - OK
        Silkkipainatus - OK
        Sublimaatiopainatus - OK
        Tampopainatus - ok
        Brodeeraus - OK
        Siirtokuvapainatus - OK
        Laserkaiverrus -OK
        Uv-laserkaiverrus - OK
        3D brodeeraus
        Kudottu merkki
        Painettu kangasmerkki
        Täysväripainettu kangasmerkki
        Keinonahkamerkki
        Heijastava painatus 
        */
        wholesalesOrderStylesObject:{
            email:{fi:"Sähköposti", id:"email"},
            online:{fi:"Netistä", id:"online"},
        },
        wholesalesOrderStyles:[
            {fi:"--Ei valittu--", id:""},
            {fi:"Sähköposti", id:"email"},
            {fi:"Netistä", id:"online"},
        ],
        numberOfPrintColors:[1,2,3,4,5,6,7,8,9,10],
        printFormats: [
            {id:"embroided_3D", fi:"3D brodeeraus", en:'3D embroidery'},
            {id:"embroided", fi:"Brodeeraus", en:"Embroidery"},
            {id:"digital_print", fi:"Digitaalinen painatus", en:"Digital print"},
            {id:"foil", fi:"Foliopainatus", en:"Foil print"},
            {id:"reflective_print", fi:"Heijastava painatus", en:"Reflective print"},
            {id:"no_print", fi:"Ilman painatusta", en:"No print"},
            {id:"leatherette_print", fi:"Keinonahkamerkki", en:'Faux leather badge'},
            {id:"woven", fi:"Kudottu merkki", en:"Woven badge"},
            {id:"laser", fi:"Lasermerkkaus", en:"Laser engraving"},
            {id:"printed_fabric", fi:"Painettu kangasmerkki", en:"Printed badge"},
            {id:"paper_print", fi:"Paperipainatus", en:"Lithographic print"},
            {id:"decal", fi:"Siirtokuva",en:"Transfer print"},
            {id:"uv_decal_360", fi:"360 UV-siirtokuvapainatus",en:"360 UV decal"},
            {id:"doming", fi:"Suojakupupainatus",en:"Doming"},
            {id:"silk", fi:"Silkkipainatus", en:"Screen print"},
            {id:"rounded_silk", fi:"Pyörösilkkipainatus", en:"Rounded screen print"},
            {id:"stamped", fi:"Stanssaus", en:"Die-cut"},
            {id:"sublimation", fi:"Sublimaatiopainatus",en:"Submilation print"},
            {id:"tampo", fi:"Tampopainatus", en:"Pad print"},
            {id:"fullcolor_fabric", fi:"Täysväripainettu kangasmerkki", en:"Full color printed badge"},
            {id:"fullcolor_print", fi:"Täysvärinen painatus", en:"Full color print"},
            {id:"uv_laser", fi:"UV-laserkaiverrusmerkkaus", en:"UV laser engraving"},
        ],
        referenceOptions:[
            {text:'Referenssi saatu',id:'referenceReceived'},
            {text:'Referenssi ei saatu',id:'referenceNotReceived'},
            {text:'En muistanut kysyä',id:'didNotRemember'}
        ],
        printFormatsObject: {
            no_print:{fi:"Ilm. painatusta", en:"No print",id:"no_print", description:"Ei merkkausta"},
            embroided:{id:"embroided", fi:"Brodeeraus", en:"Embroidery", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Brodeeraus on menetelmä jossa kuvio tai teksti muodostetaan langan avulla pistämällä sitä tiheästi kankaan läpi ja se sopii monille materiaaleille kuten tekstiileille, neuleille ja nahalle, mahdollistaen useiden värien käytön."},
            sublimation:{id:"sublimation", fi:"Sublimaatiopainatus", en:"Submilation print", colorSpecsNeeded:false, logoSpecsNeeded:false, description:"Sublimaatiopainatus on menetelmä jossa väri siirtyy kaasumaisesta olomuodosta suoraan materiaalin kuituihin korkean lämmön sekä paineen avulla ja se sopii erityisesti polyesteripohjaisille tekstiileille, mukeille, hiirimatoille ja muille erityiskäsitellyille pinnoille. Sublimaatiopainatus mahdollistaa värikkäitä ja tarkkoja kuvioita."},
            tampo:{id:"tampo", fi:"Tampopainatus", en:"Pad print", colorSpecsNeeded:true, logoSpecsNeeded:true, description:"Tampopainatus on menetelmä jossa väri siirretään elastiselta silikoonimateriaalilta pienelle silikoniselle tyynylle ja sitten siirretään haluttuun pintaan ja se sopii monille materiaaleille kuten muoville, metallille, lasille ja kankaalle."},
            stamped:{id:"stamped", fi:"Stanssaus", en:"Die-cut", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Logo prässätään tuotteeseen 3D efektin saavuttamiseksi, tässä merkkaus menetelmässä ei käytetä painoväriä."},
            laser:{id:"laser", fi:"Lasermerkkaus", en:"Laser engraving",  colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Laserkaiverrus on menetelmä jossa laser säteilee materiaalin pinnalle polttaen tai höyrystäen sen pois ja se sopii monille materiaaleille kuten puulle, akryylille, metallille ja lasille. Merkkausväri vaihtelee merkattavan tuotteen värin mukaan ja täten ei ole vapaasti valittavissa."},
            uv_laser:{id:"uv_laser", fi:"UV-laserkaiverrusmerkkaus", en:"UV laser engraving", colorSpecsNeeded:false, logoSpecsNeeded:true,description:"UV-laserkaiverrus on menetelmä jossa UV-laser polttaa tai haihduttaa materiaalin pintaa ja se sopii monille materiaaleille kuten metallille, muoville, lasille ja keraamille, mahdollistaen yleensä yksivärisen merkkauksen."},
            embroided_3D:{id:"3d_embroided", fi:"3D brodeeraus", en:"3D embroidery", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"3D-brodeeraus on tekniikka jossa langat nostetaan kankaan pinnan yläpuolelle luoden kolmiulotteisia kuvioita ja se sopii erityisesti tekstiilimateriaaleille kuten puuvillalle, froteelle, fleecekankaalle ja polyesterille."},
            woven:{id:"woven", fi:"Kudottu merkki", en:"Woven badge", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Kudottu merkki on valmistettu kudotusta langasta ja sopii erityisesti tekstiili-, neule- ja nahkamateriaaleille, mahdollistaen monivärisen toteutuksen."},
            printed_fabric:{id:"printed_fabric", fi:"Painettu kangasmerkki", en:"Printed badge",  colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Painettu kangasmerkki on valmistettu painetusta kankaasta ja sopii erityisesti tekstiili-, neule- ja nahkamateriaaleille, mahdollistaen monivärisen toteutuksen."},
            fullcolor_fabric:{id:"fullcolor_fabric", fi:"Täysväripainettu kangasmerkki", en:"Full color printed badge", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Täysväripainettu kangasmerkki on valmistettu kudotusta tai painetusta kankaasta ja sopii erityisesti tekstiili-, neule- ja nahkamateriaaleille, mahdollistaen rajattoman määrän värejä ja tarkkoja kuvioita."},
            leatherette_print:{id:"leatherette_print", fi:"Keinonahkamerkki", en:"Faux leather badge", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Keinonahkamerkki on valmistettu keinonahkamateriaalista ja se sopii useimmille tekstiili-, nahka- ja muovimateriaaleille. Keinonahkamerkit tehdään stanssauksella jolloin painoväriä ei tule tuotteeseen."},
            reflective_print:{id:"reflective_print", fi:"Heijastava painatus", en:"Reflective print", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Heijastava painatus on painotekniikka jossa käytetään heijastavia pigmenttejä tai materiaaleja, jotka heijastavat valoa takaisin lähteeseen. Se sopii useimmille tekstiili-, muovi- ja metallimateriaaleille, mahdollistaen yleensä yhden värin toteutuksen."},
            decal:{id:"decal", fi:"Siirtokuva", en:"Transfer print",  colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Siirtokuva on painotekniikka jossa kuva siirretään väliaikaiselle pinnalle ja sitten siirretään pysyvästi haluttuun materiaaliin ja se sopii useimmille materiaaleille kuten tekstiileille, lasille, keramiikalle ja puulle. Siirtokuva mahdollistaa yleensä monivärisen toteutuksen."},
            uv_decal_360:{id:"uv_decal_360", fi:"360 UV-siirtokuvapainatus", en:"360 UV decal", colorSpecsNeeded:false, logoSpecsNeeded:true,description:"360 asteinen ympäripainatus UV-siirtokuvalla."},
            doming:{id:"doming",fi:"Suojakupupainatus",en:"Doming",colorSpecsNeeded:false, logoSpecsNeeded:true,description:"Suojakupupainatuksella saadaan aikaan näyttävä 3D-mallinen kohopainatus, joka muistuttaa muodoltaan pinssiä painoalueella, näyttäen kuvun muotoisena pinnassa."},
            silk:{id:"silk", fi:"Silkkipainatus", en:"Screen print", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Silkkipainatus on menetelmä jossa väri siirretään painetusta ruudukosta materiaalille ja se sopii useimmille tekstiileille, kuten puuvillalle, polyesterille ja silkille, mahdollistaen monivärisen toteutuksen."},
            rounded_silk:{id:"rounded_silk", fi:"Pyörösilkkipainatus", en:"Rounded screen print", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Silkkipainatus on menetelmä jossa väri siirretään painetusta ruudukosta materiaalille ja se sopii useimmille tekstiileille, kuten puuvillalle, polyesterille ja silkille, mahdollistaen monivärisen toteutuksen."},
            foil:{id:"foil", fi:"Foliopainatus", en:"Foil print", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Foliopainatus on painotekniikka joka sopii useimmille sileille materiaaleille kuten paperille, kartongille, pahville, nahalle ja muoville. Sitä käytetään korostamaan kiiltäviä ja koristeellisia yksityiskohtia painotuotteissa lämmön ja paineen avulla."},
            digital_print:{id:"digital_print", fi:"Digitaalinen painatus", en:"Digital print", colorSpecsNeeded:true, description:"Digipainatus on painotekniikka, jossa kuvat siirretään suoraan tietokoneelta painettavalle pinnalle. Se sopii monille materiaaleille kuten paperille, kankaille, muoveille ja metallille. Mahdollistaen käytännössä rajattoman määrän värejä ja monimutkaisia kuvioita."},
            fullcolor_print:{id:"fullcolor_print", fi:"Täysvärinen painatus", en:"Full color print", colorSpecsNeeded:false, logoSpecsNeeded:true, description:"Täysvärinen painatus on painotekniikka jossa käytetään kaikkia CMYK-värejä ja se sopii monille materiaaleille kuten paperille, kartongille, tekstiileille ja muoville, mahdollistaen rajattoman määrän värejä ja monimutkaisia kuvioita."},
            paper_print:{id:"paper_print", fi:"Paperipainatus", en:"Lithographic print", colorSpecsNeeded:true, logoSpecsNeeded:true, description:"Paperipainatus on painotekniikka jossa kuvio tai teksti siirretään paperille painamalla ja se sopii erityisesti paperituotteille kuten julisteille, esitteille ja kirjekuorille, mahdollistaen monivärisen toteutuksen."}
            /* Linssitarra
            Painetun tarran päälle tehdään muovinen linssi, joka saa aikaan 3D efektin ja suojaa tarraa.             */
        },
        billingFormats: {
            paper: {fi:"Paperilasku", id:"paper"},
            eInvoice: {fi:"Verkkolasku", id:"eInvoice"},
            email: {fi:"Sähköpostiin", id:"email"},
            //scan: {fi:"Skannattu", id:"scan"},
        },
        roles: ["sales","office","warehouse"],
        orderedProductSampleStatusArray: [
            {text:"Uusi", id: "new", step:"all", nextStepResponsible:"office"}, 
            {text:"Mallikappaleet lähetetty", id: "samplesShipped", step:"all",nextStepResponsible:"varasto" },
            {text:"Tuotteet siirretty hyllylytä pakettiin", id: "productsTransferredToPackage", step:"all", nextStepResponsible:"varasto"}, 
            {text:"Mallikappaleet palautettu", id: "samplesReturned", step:"all",nextStepResponsible:"varasto" },
        ],
        orderedProductWarehouseStatusArray: [
            {text:"Allokoitu saapuneeseen erään", id: "allocatedToArrived"}, 
            {text:"Allokoitu saapuvaan erään", id: "allocatedToArriving"}, 
            {text:"Ei allokoitu", id: "unallocatedAvecor" },

            {text:"Yli 100 kappaletta vielä varastossa tilaushetkenä", id: "over100" },
            {text:"51 - 100 kappaletta varastossa tilaushetkenä", id: "over50andLessEqualTo100" },
            {text:"0-50 kappaletta varastossa tilaushetkenä", id: "over0andLessEqualTo50" },
            {text:"Varastosaldo miinuksella.", id: "less0" },
            
            
        ],
        shelfLocationArray:[
            "A1","A2","A3","A4","A5","A6","A7","A8","A9","A10","A11","A12",
            "B1","B2","B3","B4","B5","B6","B7","B8","B9","B10","B11","B12",
            "C1","C2","C3","C4","C5","C6","C7","C8","C9","C10","C11","C12",
            "D1","D2","D3","D4","D5","D6","D7","D8","D9","D10","D11","D12",
            "E1","E2","E3","E4","E5","E6","E7","E8","E9","E10","E11","E12",
            "F1","F2","F3","F4","F5","F6","F7","F8","F9","F10","F11","F12",
            "G1","G2","G3","G4","G5","G6","G7","G8","G9","G10","G11","G12",
            "H1","H2","H3","H4","H5","H6","H7","H8","H9","H10","H11","H12",
            "I1","I2","I3","I4","I5","I6","I7","I8","I9","I10","I11","I12",
            "J1","J2","J3","J4","J5","J6","J7","J8","J9","J10","J11","J12",
            "K1","K2","K3","K4","K5","K6","K7","K8","K9","K10","K11","K12",
            "L1","L2","L3","L4","L5","L6","L7","L8","L9","L10","L11","L12",
            "M1","M2","M3","M4","M5","M6","M7","M8","M9","M10","M11","M12",
            "N1","N2","N3","N4","N5","N6","N7","N8","N9","N10","N11","N12",
        ],
        numberOfPackagesArray: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15],
        orderedProductStatusArray: [
            {text:"Uusi", id: "new", step:"all", nextStepResponsible:"office"}, 
            {text:"Odottaa tietoa", id: "waitingInfo", step:"all", nextStepResponsible:"office"}, 
            //{text:"Deadline tilaukset", id: "deadline", step:"all", nextStepResponsible:"office"}, 
            
            {text:"Tilaus myöhemmin", id: "processLater", step:"all", nextStepResponsible:"office"}, 
            {text:"Koonti perjantaina", id: "compileProducts", step:"all", nextStepResponsible:"office"}, 
            {text:"Logo pyydetty asiakkaalta", id: "logoRequested", step:"print", nextStepResponsible:"office"}, 
            {text:"Logo muistutus lähetetty", id: "logoReminderSent", step:"print", nextStepResponsible:"office"}, 
            {text:"Lähetä tuotteet merkkaamoon", id: "sendProductsToPrint", step:"print", nextStepResponsible:"varasto"}, 
            //{text:"Logo saapunut", id: "logoArrived", step:"print", nextStepResponsible:"office"}, 
            {text:"Vedos tilattu toimittajalta", id: "draftOrdered", step:"print", nextStepResponsible:"office"}, 
            {text:"Vedos lähetetty asiakkaalle", id: "draftSentToCustomer", step:"print", nextStepResponsible:"office"}, 
            {text:"Vedos muistutus toimittajalta", id: "draftOrderedReminder", step:"print", nextStepResponsible:"office"}, 
            //{text:"Vedos saapunut toimittajalta", id: "draftArrived", step:"print", nextStepResponsible:"office"}, 
            
            {text:"Vedos muistutus asiakkaalle", id: "draftReminder1", step:"print", nextStepResponsible:"office"}, 
            //{text:"Vedos muistutus 2 lähetetty asiakkaalle", id: "draftReminder2", step:"print",nextStepResponsible:"office"}, 
            {text:"Myyjää pyyd. kontak.", id: "salesRequestedToContact", step:"print", nextStepResponsible:"office"},
            {text:"Myyjää pyyd. kontak. LOGO", id: "salesRequestedToContactForLogo", step:"print", nextStepResponsible:"office"},
            {text:"Myyjää pyyd. kontak. VEDOS", id: "salesRequestedToContactForDraft", step:"print", nextStepResponsible:"office"},
            //{text:"Asiakas hyväksynyt vedoksen", id: "draftAccepted", step:"print", nextStepResponsible:"office"}, 
            {text:"Tilaus tehty toimittajalle", id: "orderCreated", step:"all", nextStepResponsible:"varasto"}, 
            {text:"Tilaus tehty muistutus", id: "orderCreatedReminder", step:"all", nextStepResponsible:"office"}, 
            //{text:"Tilaus tehty merkkaamoon", id: "orderCreatedToPrintShop", step:"print", nextStepResponsible:"varasto"}, 
            {text:"Odottaa saapuvaa erää", id: "awaitingBatch", step:"all", nextStepResponsible:"varasto"}, 
            //{text:"Tuotteet lähetetty merkkaamoon", id: "productsSentToPrint", step:"print", nextStepResponsible:"varasto"}, 
            {text:"Tuotteet saapuneet varastoon", id: "productsArrivedToWarehouse", step:"all", nextStepResponsible:"varasto"}, 
            
            {text:"Keskeneräiset hylly", id: "incompleteShelf", step:"all", nextStepResponsible:"varasto"}, 
            {text:"Tilaus myöh. / keskeneräiset", id: "orderLaterIncompleteShelf", step:"all", nextStepResponsible:"varasto"}, 
            //{text:"Tuotteet siirretty pakettiin", id: "productsTransferredToPackage", step:"warehouseProducts", nextStepResponsible:"varasto"}, 
            {text:"Tuotteet lähetetty asiakkaalle", id: "productsShipped", step:"all",nextStepResponsible:"office" },
            {text:"Tilaus peruttu", id: "cancelled", step:"all",nextStepResponsible:"office" }
        ],
        orderedProductStatusObject: {
            new: {text:"Uusi", step:"all", nextStepResponsible:"office", order:10}, 
            waitingInfo:{text:"Odottaa tietoa", step:"all", nextStepResponsible:"office", order:20}, 
            deadline:{text:"Deadline tilaukset", step:"all", nextStepResponsible:"office", order:30}, 
            processLater:{text:"Tilaus myöhemmin", step:"all", nextStepResponsible:"office", order:40}, 
            
            compileProducts: {text:"Koonti perjantaina", step:"print", nextStepResponsible:"office",order:50}, 
            logoRequested: {text:"Logo pyydetty asiakkaalta", step:"print", nextStepResponsible:"office",order:60}, 
            logoReminderSent: {text:"Logo muistutus lähetetty", step:"print", nextStepResponsible:"office",order:65}, 
            sendProductsToPrint: {text:"Lähetä tuotteet merkkaamoon", step:"print", nextStepResponsible:"varasto",order:70}, 
            logoArrived: {text:"Logo saapunut", step:"print", nextStepResponsible:"office",order:80}, 
            draftOrdered: {text:"Vedos tilattu toimittajalta", step:"print", nextStepResponsible:"office",order:90},
            draftOrderedReminder: {text:"Vedos muistutus toimittajalta", step:"print", nextStepResponsible:"office",order:90},
            draftArrived: {text:"Vedos saapunut toimittajalta", step:"print", nextStepResponsible:"office",order:100}, 
            draftSentToCustomer: {text:"Vedos lähetetty asiakkaalle", step:"print", nextStepResponsible:"office",order:110}, 
            draftReminder1: {text:"Vedos muistutus asiakkaalle", step:"print", nextStepResponsible:"office",order:120}, 
            draftReminder2: {text:"Vedos muistutus 2 asiakkaalle", step:"print",nextStepResponsible:"office",order:130}, 
            salesRequestedToContact: {text:"Myyjää pyyd. kontak.", step:"print", nextStepResponsible:"office",order:140},
            salesRequestedToContactForLogo: {text:"Myyjää pyyd. kontak. LOGO", step:"print", nextStepResponsible:"office",order:140},
            salesRequestedToContactForDraft: {text:"Myyjää pyyd. kontak. VEDOS", step:"print", nextStepResponsible:"office",order:140},
            draftAccepted: {text:"Asiakas hyväksynyt vedoksen", step:"print", nextStepResponsible:"office",order:150}, 
            orderCreated: {text:"Tilaus tehty toimittajalle", step:"all", nextStepResponsible:"varasto",order:160}, 
            orderCreatedReminder: {text:"Tilaus tehty muistutus", step:"all", nextStepResponsible:"varasto",order:162}, 
            //orderCreatedToPrintShop: {text:"Tilaus tehty merkkaamoon", step:"print", nextStepResponsible:"varasto",order:160}, 
            awaitingBatch:{text:"Odottaa saapuvaa erää", id: "awaitingBatch", step:"all", nextStepResponsible:"varasto",order:165}, 
            productsSentToPrint: {text:"Tuotteet lähetetty merkkaamoon", step:"print", nextStepResponsible:"varasto",order:170}, 
            productsArrivedToWarehouse: {text:"Tuotteet saapuneet varastoon", step:"all", nextStepResponsible:"varasto",order:180}, 
            incompleteShelf: {text:"Keskeneräiset hylly", step:"all", nextStepResponsible:"varasto",order:190}, 
            orderLaterIncompleteShelf:{text:"Tilaus myöh. / keskeneräiset", step:"all", nextStepResponsible:"varasto",order:195}, 
            productsTransferredToPackage: {text:"Tuotteet siirretty lähetettävään pakettiin", step:"all",nextStepResponsible:"varasto",order:200 },
            productsShipped: {text:"Tuotteet lähetetty asiakkaalle", step:"all",nextStepResponsible:"office",order:210 },
            cancelled: {text:"Tilaus peruttu", step:"all",nextStepResponsible:"office",order:220 },

            samplesShipped: {text:"Mallikappaleet lähetetty", step:"all", nextStepResponsible:"varasto",order:210}, 
            samplesReturned: {text:"Mallikappaleet palautettu", step:"all",nextStepResponsible:"varasto",order:240 },
            //samplesReturned: {text:"Mallikappaleet valmis", step:"all",nextStepResponsible:"varasto" },
        },
        invoiceStatusObject:{
            open:{text:"Auki (Open)"},
            unsent:{text:"Ei lähetetty (Unset)"},
            overdue:{text:"Erääntynyt (Overdue)"},
            paid:{text:"Maksettu (Paid)"},
            reminded:{text:"Muistutettu (Reminded)"},
            requested:{text:"Huomautettu (Requested)"},
            collected:{text:"Perinnässä (Collected)"},
            creditloss:{text:"Luottotappio (Credit loss)"},
            rejected:{text:"Torjuttu (Rejected)"}
        },
        
        orderStatusColors:{
            //WAREHOUSE STATUS INDICATORS
            allocated:"#2ECC40", //Green
            allocatedToArrived:"#2ECC40", //Green
            allocatedToArriving:"#ff982e", //Orange
            unallocatedAvecor:"#ff2f00", // Dark red
            unallocatedPrintShop:"#ff2f00", // Dark red
            over100:"#2ECC40", //Green
            over50andLessEqualTo100:"#90EE90", //Light Green
            over0andLessEqualTo50:"#ff982e", //Orange
            less0:"#ff2f00", // Dark red
            //ORDER STATUS INDICATORS
            new: "#cccccc",
            processLater: "#cccccc",
            waitingInfo:"#cccccc",
            deadline:"#ff2f00",
            compileProducts: "#cccccc",
            logoRequested:"#85929E", // web asphault "#FFDC00",
            logoReminderSent:"#85929E", // web asphault "#FFDC00",
            logoArrived:"#FFDC00", 
            draftOrdered:"#9932CC", // Purple
            draftOrderedReminder:"#9932CC",
            draftArrived:"#FFDC00",
            draftSentToCustomer:"#220CC9", // Dark blue
            draftReminder1:"#220CC9", // Dark blue
            draftReminder2:"#220CC9", // Dark blue
            salesRequestedToContact:"#ff2f00", // Dark red
            salesRequestedToContactForLogo:"#ff2f00", // Dark red
            salesRequestedToContactForDraft:"#ff2f00", // Dark red
            draftAccepted:"#FFDC00",
            orderCreated:"#FFFF00", // Yellow
            orderCreatedReminder:"#FFFF00", // Yellow
            awaitingBatch:"#800000", // Maroon
            orderCreatedToPrintShop:"#FFFF00", // Yellow
            productsSentToPrint:"#7B3F01",
            sendProductsToPrint:"#2196F3", // Blue
            productsArrivedToWarehouse:"#ff982e", // Orange
            incompleteShelf:"#ff982e", // Orange
            orderLaterIncompleteShelf:"#ff982e", // Orange
            productsTransferredToPackage:"#FFFF00", // Yellow
            samplesShipped:"#2196F3", // Blue
            productsShipped:"#2ECC40", // Green
            samplesReturned:"#2ECC40", // Green
            //INVOICE STATUS INDICATORS
            doNotInvoice:"#ff2f00", // Dark red
            invoice:"#00BFFF", // Vaalean sininen
            invoiced:"#2ECC40", // Green
            cancelled:"#000000", // Black
            // INVOICE COLORS
            open:"#cccccc",
            unsent:"#cccccc",
            overdue:"#ff2f00",
            paid:"#2ECC40",
            reminded:"#ff982e",
            requested:"#ff2f00",
            collected:"#000000",
            creditloss:"#800000",
            rejected:"#800000"
        },
        eBillingOperators:[
            {id:"HELSFIHH", name:"Aktia"},
            {id:"AABAFI22", name:"Ålandsbanken"},
            {id:"003723327487", name:"Apix Messaging Oy (003723327487)"},
            {id:"00372332748700001", name:"Apix Messaging Oy (00372332748700001)"},
            {id:"BAWCFI22", name:"Basware Oyj"},
            {id:"5909000716438", name:"Comarch"},
            {id:"CREDIFLOW", name:"Crediflow Ab"},
            {id:"DABAFIHH", name:"Danske Bank"},
            {id:"DNBAFIHX", name:"DNB Bank ASA, Finland Branch"},
            {id:"HANDFIHH", name:"Handelsbanken"},
            {id:"INEXCHANGE", name:"InExchange Factorum AB (INEXCHANGE)"},
            {id:"SE556700997101", name:"InExchange Factorum AB (SE556700997101)"},
            {id:"EXPSYS", name:"Lexmark Expert Systems AAB"},
            {id:"003721291126", name:"Maventa"},
            {id:"003726044706", name:"Netbox Finland Oy"},
            {id:"NETBFI99", name:"Netvisor eBank"},
            {id:"NDEAFIHH", name:"Nordea"},
            {id:"003717203971", name:"Notebeat Oy"},
            {id:"003708599126", name:"Open Text Oy"},
            {id:"E204503", name:"OpusCapita Solutions Oy"},
            {id:"OKOYFIHH", name:"Osuuspankki"},
            {id:"003723609900", name:"Pagero"},
            {id:"PEPPOL", name:"PEPPOL"},
            {id:"POPFFI22", name:"POP Pankki"},
            {id:"FI28768767", name:"Posti Messaging Oy / Orbyt AS"},
            {id:"003701150617", name:"PostNord Strålfors Oy"},
            {id:"003714377140", name:"Ropo Capital"},
            {id:"SBANFIHH", name:"S-Pankki/LähiTapiola"},
            {id:"ITELFIHH", name:"Säästöpankki"},
            {id:"SPROOM", name:"Sproom ApS"},
            {id:"003714756079", name:"-- EI KÄYTÖSSÄ NETVISORISSA ENÄÄN -- TeliaSonera Finland Oyj"},
            {id:"003703575029", name:"Telia / CGI Suomi (ent. Logica)"},
            {id:"003701011385", name:"Tieto Oyj"},
        ],
        orderedProductInvoiceStatusArray: [
            {text:"Ei saa laskuttaa", id: "doNotInvoice"},  
            {text:"Saa laskuttaa", id: "invoice", nextStepResponsible:"office"},  
            {text:"Laskutettu", id: "invoiced"}, 
            /* {text:"Ei laskutusta", id: "notToBeInvoiced"},  */
        ],
        orderedProductInvoiceStatusObject: {
            doNotInvoice:{text:"Ei saa laskuttaa", id: "doNotInvoice"},  
            invoice:{text:"Saa laskuttaa", id: "invoice", nextStepResponsible:"office"},  
            invoiced:{text:"Laskutettu", id: "invoiced"}, 
            /* notToBeInvoiced:{text:"Ei laskutusta", id: "notToBeInvoiced"},  */
        },
        orderedProductInvoiceStyles:[
            {text:"Laskutus kun tuotteet toimitettu", id: "invoiceAfterProductsSent"}, 
            {text:"Laskutus tietyn päivämäärän jälkeen", id: "invoiceAfterDate"},  
        ],
        orderedProductStockStatusObject: {
            available:{text:"Saldo OK", id: "available",color:"#2ECC40"},  
            availableButLowerThanStockNotifyLevel:{text:"Saldo OK, hälytysraja alitettu", id: "availableButLowerThanStockNotifyLevel",color:"#ff982e"},  
            notAvailable:{text:"Saldoa puuttuu", id: "notAvailable", color:"#ff2f00"},  
        },
        env: (window.location.hostname.includes("localhost") || window.location.hostname.includes("-dev")) ? "development" : "production",
        officeEmail: (window.location.hostname.includes("localhost") || window.location.hostname.includes("-dev")) ? "tomi.hokkanen@avecor.fi" : "tilaukset@avecor.fi",
        isOffice: window.location.hostname.includes("toimisto") || window.location.hostname.includes("office") || window.location.hostname.includes("localhost"),
        isSales: window.location.hostname.includes("myynti") || window.location.hostname.includes("sales"),// || window.location.hostname.includes("avecor-709ff"),
        isWarehouse: window.location.hostname.includes("varasto") || window.location.hostname.includes("warehouse"),
        isAdmin: window.location.hostname.includes("admin"),
        isPlanner: !this.isMockup,
        clippedToolbar:true,
        avatarSize:34,
        
        snackSettings:{
            snack: false,
            snackColor: '',
            snackText: '',
            snackTimeout:3000,
            snackButtonText:'Sulje',
            errorType:'',
            top:false,
            right:false
        },
        rootUrl: window.location.port != 80 ? window.location.hostname+":"+window.location.port : window.location.hostname,
        dev: (window.location.hostname.includes("localhost") || window.location.hostname.includes("-dev")),
        showUnauthenticatedUserMessage:true,
        signInLoader:false,
        max25chars: v => v.length <= 25 || 'Input too long!',
        noPeriods: v => !/[,]/.test(v) || 'Käytä pistettä pilkun sijaan!',
        noCommas: v => !/[,]/.test(v) || 'Käytä pistettä pilkun sijaan!',
        required: value => (!!value && value != 0 && value.trim() !== "") || 'Täytä kenttä.',
        requiredForProduct: value => (!!value && value != 0) || 'Täytä kenttä.',
        email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return (pattern.test(value) || value==="") || 'Invalid e-mail.'
        }
    },
    newPromotionDetails: {
        promotionEmailSubject:"",
        promotionMainHeadline:"",
        promotionMainSubHeader:"",
        promotionValidDate: dateFormat(new Date().setDate(new Date().getDate()+30), "yyyy-mm-dd"),
        promotionTemplateName:"",
        selectedExistingOrderId:"",
        selectedExistingPromotionId:"",
        selectedPromotionTemplateId:"",
        selectedCompanyId:"",
        selectedContactId:"",
        selectedProductId:"",
        existingCompanySelected:false,
        existingContactSelected:false,
        existingProductSelected:false,
        differentBillingAddress:false,
        differentBillingEmail:false,
        productNumber: 3,
        billingFormat: '',
        salesperson: '',
        firstName: '',
        lastName: '',
        additionalCustomerInformation: '',
        clientName: '',
        clientPhone: '',
        clientEmail: '',
        sendConfirmation: false,
        contactsArray:[
            {
                clientName: '',
                clientPhone: '',
                clientEmail: '',
            }
        ],
        clientOrderDetailsEmail: '',
        companyName: '',
        companyId: '',
        deliveryAddress:"",
        deliveryPostalCode:"",
        deliveryCity:"",
        deliveryCountry:"Finland",
        billingReferenceDetails:"",
        billingAddress:"",
        billingPostalCode:"",
        billingCity:"",
        billingCountry:"",
        billingEmail:"",
        billingEInvoiceNumber:"",
        eBillingAddress:"",
        eBillingOperator:"",
        seperateBillingAddress: '',
        paymentTerm: '14 päivää netto',
        paymentTermNetvisor:14,
        samplesArray: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],
        orderDate: new Date().toISOString().substr(0, 10),
        orderReference: '',
        orderDeliveryMethod: 'Posti',
        orderComments: '',
        sendOrderCommentsInConfirmation:false,
        positioningCharges: 0.00, 
        deliveryCharges: "24,90", 
        products: [],
        productsErrors: []
    },
    newRecords: {
        newProductVariation: {
            sku: '',
            color: '',
            colorCode:'',
            packageType: '',
            shape:'',
            gender: '',
            material: '',
            other:'',
            deliveryTime: '',
            smallOrderLimit: 0,
            smallOrderExtra: 0,
            minimumOrderQuantity: 10,
            unitPurchasePrice: 0,
            unitPrintColorPrice: 'ei asetettu',
            printLocation:'',
            firstPrintColorIncluded: true,
            chargePerPrintColor: true,
            additionalInfo: '',
            stock:'ei asetettu'
        }
    },
    newOrderDetails: {
        selectedExistingOrderId:"",
        selectedCompanyId:" ",
        selectedDeliveryWeek:'',
        selectedContactId:"",
        selectedProductId:"",
        existingCompanySelected:false,
        existingContactSelected:false,
        existingProductSelected:false,
        differentBillingAddress:false,
        differentBillingEmail:false,
        isSamplesOrder:false,
        typeOfOrder:'normal',
        selectedSamplePackage:'',
        selectedSamplePackageProductVariations:[],
        productNumber: 3,
        billingFormat: '',
        salesperson: '',
        firstName: '',
        lastName: '',
        language:'fi',
        additionalCustomerInformation: '',
        clientName: '',
        clientPhone: '',
        clientEmail: '',
        knownOperator:false,
        sendDraftsToSalesperson:false,
        sendConfirmation: false,
        splitInvoice:false,
        doNotSendConfirmation:false,
        doNotSendMaterialRequestEmail:false,
        contactsArray:[
            {
                clientName: '',
                clientPhone: '',
                clientEmail: '',
            }
        ],
        
        clientOrderDetailsEmail: '',
        clientPrintDetailsEmail: '',
        companyName: '',
        companyId: '',
        industry:'',
        deliveryAddress:"",
        deliveryPostalCode:"",
        deliveryCity:"",
        deliveryCountry:"Finland",
        
        billingReferenceDetails:"",
        billingAddress:"",
        billingPostalCode:"",
        billingCity:"",
        billingCountry:"Finland",
        billingEmail:"",
        billingEInvoiceNumber:"",
        eBillingAddress:"",
        eBillingOperator:"",
        seperateBillingAddress: '',
        paymentTerm: '14 päivää netto',
        paymentTermNetvisor:14,
        samplesArray: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25],
        orderDate: new Date().toISOString().substr(0, 10),
        orderReference: '',
        orderDeliveryMethod: 'Posti',
        orderComments: '',
        sendOrderCommentsInConfirmation:false,
        positioningCharges: 0.00, 
        deliveryCharges: "24.90", 
        deliveryBySalesperson:false,
        isAmendmentOrder:false,
        referenceOption:"",
        referenceText:'',
        products:[],
        products2: [ 
            {
                sample:false,
                productId: '',
                productVariationId: '',
                customerProductName: '',
                productName:'',
                sku:'',
                warehoused:false,
                quantity: '',
                color: '',
                size: '',
                numberOfSamples: 0,
                unitPrice: '',
                unitPrintPrice:'',
                printQuantity:'',
                printCostComments:'',
                packageType:'',
                numberOfPositionings: 1,
                pricePerPositioning:0,
                printOptions:[],
                printOptions2:[],
                printFormats:[],
                printFormats2:[],
                newPrintOptionsInUse:false,
                printOptionsSettings:{},
                printOptionsSettings2:{},
                //printOptionsRenewal:{},
                //printOptionsColors:{},
                printFormatsText:'',
                numberOfPrintColors:null,
                numberOfPrintColors2:null,
                print: false,
                secondPrint:false,
                printColor: "",
                printLocation: "",
                printContent: "",
                printComments: "",
                printColor2: "",
                printLocation2: "",
                printContent2:"",
                printComments2: "",
                latestToCustomer: '',
                whenToInvoice:'',
            },
        ],
        productsErrors: [
            {
                sample:'',
                productId: '',
                productVariationId: '',
                customerProductName: '',
                productName:'',
                sku:'',
                packageType:'',
                quantity: '',
                color: '',
                size: '',
                numberOfSamples: '',
                unitPrice: '',
                unitPrintPrice: '',
                printQuantity: '',
                printCostComments:'',
                numberOfPositionings: '',
                pricePerPositioning:'',
                printFormats:'',
                printFormats2:'',
                printOptions:'',
                printOptions2:'',
                printOptionsSettings:'',
                //printOptionsRenewal:'',
                //printOptionsColors:'',
                printFormatsText:'',
                printFormatsText2:'',
                numberOfPrintColors:'',
                numberOfPrintColors2:'',
            },
        ],
        productsOtherInfo: [
            {
                existingProductSelected:false
            },
        ],
       
    },
    appTitle: 'Avecor Tilauskeskus',
    user: "",
    error: null,
    loading: false,
    channel:null,
    adType:null,
    selectedItem:null,
    tree: [],
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    newRow: {
        value: '',
        label: '',
        icon:''
    },
    labels: [ { id:0, percentual: 87, label:'Mandorle', icon:'fa-user-circle-o' } ],
    nextBarId: 1
  },
  mutations: {
    updateField,
    setUser (state, payload) {
        state.user = payload
    },
    setSalesperson (state, payload) {
        state.newOrderDetails.salesperson = payload
    },
    setError (state, payload) {
        state.error = payload
    },
    setIsSyncOrderToNetvisorActive (state, payload) {
        state.isSyncOrderToNetvisorActive = payload
    },
    setLoading (state, payload) {
        state.loading = payload
    },
    setUrlId (state, payload) {
        state.settings.urlId = payload
    },
    setLoaded(state,payload){
        state.settings.loaded = true
    },
    setLoadingOverlay (state, payload) {
        state.settings.loadingOverlay = payload
    },
    setView (state, payload) {
        state.settings.isSales ? state.selectedView.salesView = payload : ''
        state.settings.isOffice ? state.selectedView.officeView = payload : ''
    },
    setSearch (state, payload) {
        payload === "orders" ? state.settings.ordersSearch = state.settings.urlId : null
        //state.settings.urlId = payload
    },
    setUnauthenticatedUserMessage (state,payload) {
        state.settings.showUnauthenticatedUserMessage = payload
    },
    newRow(state, row) {
        state.newOrderDetails.productNumber = row.number
        //state.newOrderDetails.products.push(row)
        state.newOrderDetails.productsErrors.push(row.productError)
        state.newOrderDetails.productsOtherInfo.push(row.productOtherInfo)
        state.newOrderDetails.products2.push(row.product)
    },
    addProductToPromotion(state, row) {
        //state.newPromotionDetails.productNumber = row.number
        state.newPromotionDetails.productsErrors.push(row.productError)
        state.newPromotionDetails.products.push(row.product)
    },
    addPriceOfferToProduct(state, details) {
        state.newPromotionDetails.products[details.productNumber].offers.push(details.offer)
    },
    deletePriceOfferFromProduct(state, details) {
        state.newPromotionDetails.products[details.productIndex].offers.splice(details.offerIndex,1)
    },
    updateRow(state, row) {
        state.newOrderDetails.products[row.index] = { ...state.newOrderDetails.products[row.index], ...row }
    },
    deleteRow(state, rowIndex) {
        var p =state.newOrderDetails.products2
        var s = p.filter(function (item) {
            return p.number.id != item.id;
        });
    },
    updatePromotionProducts(state, payload) {
        state.newPromotionDetails.products = payload.products
        state.newPromotionDetails.productsErrors = payload.productsErrors
    },
    updateProducts(state, newProducts) {
        state.newOrderDetails.products2 = newProducts
    },
    snackSettingsUpdate(state, newSettings) {
        state.settings.snackSettings = { ...state.settings.snackSettings, ...newSettings }
    },
    setOrderedProductsStatuses(state, newOrderedProductsStatuses) {
        state.views.orders.orderedProductsStatuses = newOrderedProductsStatuses     
    },
  },
  actions: {
    async deleteOrderOrInvoiceNetvisor({commit,state}, obj){
        try{
            var message = ''
            if(obj.invoiceType === 'invoice') message = 'Haluatko varmasti poistaa laskun?'
            else if(obj.invoiceType === 'order') message = 'Haluatko varmasti poistaa myyntitilauksen?'
            if (confirm(message)) {
                var snackText = ''
                if(obj.invoiceType === 'invoice') snackText = 'Laskua poistetaan Netvisorista...'
                else if(obj.invoiceType === 'order') snackText = 'Tilausta poistetaan Netvisorista...'
                
                var salespersonId = state.order.orders[obj.orderId].salesperson
                store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText, snackButtonText: "OK", errorType:"", snackColor:'deep-blue',right:true,top:true})
                
                await store.dispatch('syncToNetvisor', {
                    rt:"delete_order_or_invoice",
                    ...obj
                })
                
                if(obj.invoiceType === 'invoice') snackText = 'Laskua poistettu Netvisorista.'
                else if(obj.invoiceType === 'order') snackText = 'Tilaus poistettu Netvisorista'
                store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText, snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
                //commit('setIsSyncOrderToNetvisorActive', false)
            }
        }
        catch(e){
            store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:e, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            
        }
    },
    async syncCompanyToNetvisor({commit,state}, obj){
        try{
          store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Yritystä synkronoidaan Netvisoriin...", snackButtonText: "OK", errorType:"", snackColor:'deep-blue',right:true,top:true})
          var companyData = state.company.companies[obj.companyId]
          var salesperson = companyData.salesperson
          var salespersonFirstName = state.staff.staff[salesperson] && state.staff.staff[salesperson].firstName ? state.staff.staff[salesperson].firstName : ''
          var salespersonLastName = state.staff.staff[salesperson] && state.staff.staff[salesperson].firstName ? state.staff.staff[salesperson].lastName : ''
          var salespersonNetvisorKey = state.staff.staff[salesperson] && state.staff.staff[salesperson].netvisorKey ? state.staff.staff[salesperson].netvisorKey : ''
          await store.dispatch('syncToNetvisor', {
            rt:"company",
            companyData:{...companyData,salespersonFirstName,salespersonLastName,salespersonNetvisorKey},
            env:obj.env,
          })
          store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Yritys synkronoitu.", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        }
        catch(e){
            store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:e, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
        }

    },
    syncToNetvisor({commit,state}, payload){
        return new Promise(async function(resolve, reject) {
            try{
                commit('setIsSyncOrderToNetvisorActive', true)
                var url = state.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/netvisorAPI' : 'https://us-central1-avecor-709ff.cloudfunctions.net/netvisorAPI'
                var token = await firebase.auth().currentUser.getIdToken()
                axios.defaults.headers.common['Authorization'] = "Bearer " +token;
                axios.post(
                    url,
                    {
                        rt:payload.rt,
                        data:payload
                    }
                )
                .then(function(response) {
					console.log("OK")
                    console.log(response)
                    commit('setIsSyncOrderToNetvisorActive', false)
                    resolve("OK")
				})
				.catch(function(error) {
					commit('setIsSyncOrderToNetvisorActive', false)
                    let errorMessage = (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : error;
                    console.log(error)
                    console.log("ERR")
                    console.log(errorMessage)
                    reject(errorMessage)
				});
            }
            catch(e){
                console.log(e.message)
                reject(e)
            }
        })
    },
    userSignUp ({commit,state}, payload) {
        commit('setLoading', true)
        firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
            state.settings.debug ? console.log("USER SIGNED UP: "+ payload.email) : null
            store.dispatch('openEasyFirestoreChannels')
            commit('setUser', {email: firebaseUser.user.email, uid: payload.uid, createdDate: payload.metadata.creationTime})
            commit('setLoading', false)
            router.push('/planner')
            commit('setError', null)
        })
        .catch(error => {
            commit('setError', error.message)
            commit('setLoading', false)
        })
    },
    userSignIn ({commit,state}, payload) {
        commit('setLoading', true)
        firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
            state.settings.debug ? console.log("USER SIGNED IN: "+ payload.email) : null
            //store.dispatch('openEasyFirestoreChannels')
            commit('setUser', {email: firebaseUser.user.email, uid: firebaseUser.user.uid, createdDate: firebaseUser.user.metadata.creationTime})
            commit('setLoading', false)
            commit('setError', null)
            router.push('/planner')
        })
        .catch(error => {
            commit('setError', error.message)
            commit('setLoading', false)
        })
    },
    userSignInWithOnlyEmail ({commit, state}, payload) {
        commit('setLoading', true)
        var url = state.settings.dev ? 'http://clients-dev.avecor.fi/' : 'https://clients.avecor.fi/'
        var actionCodeSettings = {
          // URL you want to redirect back to. The domain (www.example.com) for this
          // URL must be whitelisted in the Firebase Console.
          url,
          // This must be true.
          handleCodeInApp: true,
        };
        firebase.auth().sendSignInLinkToEmail(payload.email, actionCodeSettings)
          .then(function() {
              // The link was successfully sent. Inform the user.
              // Save the email locally so you don't need to ask the user for it again
              // if they open the link on the same device.
              window.localStorage.setItem('emailForSignIn', payload.email);
              commit('setUser', {email: firebaseUser.user.email })
              commit('setLoading', false)
              commit('setError', null)
          })
          .catch(function(error) {
              commit('setError', error.message)
              commit('setLoading', false)
          });
    },
    sendMessageServerSide({commit,state}, payload) {
        return new Promise(async function(resolve, reject) {
            if(!payload.dontShowSending) store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Viestiä lähetetään osoitteeseen "+payload.toEmail+".", snackButtonText: "OK", errorType:"", snackColor:'deep-blue'})
            var url = state.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/sendGoogleEmail' : 'https://us-central1-avecor-709ff.cloudfunctions.net/sendGoogleEmail'
            firebase.auth().currentUser.getIdToken().then(function(token){
                axios.defaults.headers.common['Authorization'] = "Bearer " +token;
                var ops = []
                payload.opIds.forEach(opId => {
                    
                    var op = state.orderedProduct.orderedProducts[opId]
                    var pv = state.productVariation.productVariations[op.productVariationId]
                    
                    var p = state.product.products[op.productId]
                    var avecorSku = p && p.avecorSku ? p.avecorSku : ''
                    var colorName = ""
                    pv.colorCode && state.settings.colors[pv.colorCode] ? colorName = state.settings.colors[pv.colorCode].fi : ''
                    if(pv.colorCode && avecorSku) avecorSku += '-' + pv.colorCode
                    ops.push({
                        ...pv,
                        ...p,
                        ...op,
                        pv:{...pv},
                        p:{...p},
                        op:{...op},
                        color:colorName,
                        avecorSku
                    })
                })
                var order = state.order.orders[payload.orderId]
                axios.post(
                    url,
                    {
                        typeOfSend:payload.typeOfSend,
                        toEmail:payload.toEmail,
                        fromEmail:payload.fromEmail,
                        salesperson:state.staff.staff[order.salesperson],
                        customer:payload.customer,
                        contact:state.contact.contacts[payload.contactId],
                        company:state.company.companies[payload.companyId],
                        order,
                        ops,
                        opFilter:payload.opFilter ? payload.opFilter : []
                    }
                )
                .then(function(response) {
                    if(!payload.dontShowSending) store.dispatch('showSnack', { snack:true, snackTimeout:5000, snackText:"Viesti lähetetty "+payload.toEmail, snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
                    resolve(response)
                })
                .catch(function(error) {
                    console.log("IN SERVER SIDE SEND")
                    console.log(error.message)
                    var message = (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : error;
                    if(!payload.dontShowSending) store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Viestin lähetys epäonnistui:" +message+ ".", snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
                    reject(message)
                    //console.log(error);
                });
            })
        })
    },
    autoSignIn ({commit,state}, payload) {
        //state.settings.debug ? console.log("AUTOSIGNING IN: "+ payload.email) : null
        //state.settings.debug ? console.log(payload) : null
        commit('setUser', {email: payload.email, uid: payload.uid, photo: payload.photoURL, displayName:payload.displayName})
        var date = new Date()
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        var d = date.getDate()
        /* var data = {[y]:{
            [m]:{
                [d]:{
                    [payload.uid]:{
                        login:firebase.firestore.FieldValue.arrayUnion(date)
                    }
                }
            }
        }}
        var db = firebase.firestore();
        db.collection('config').doc('logs').set({ 
            data
        }, { merge: true }) */
        var year = {
            [m]:{
                [d]:{
                    [payload.uid]:{
                        login:firebase.firestore.FieldValue.arrayUnion(date)
                    }
                }
            }
        }
        var db = firebase.firestore();
        db.collection('config').doc('logs').set({ 
            [y]:year
        }, { merge: true })
        commit('setSalesperson', payload.displayName)
        commit('setUnauthenticatedUserMessage', false)
        store.dispatch('openEasyFirestoreChannels')
    },
    async changeSalespersonForCompany({commit, state},payload){
        try {
            var companyId = payload.companyId
            var newSalesperson = payload.newSalesperson
            console.log("MOVING COMPANY")
            console.log({companyId,newSalesperson})
            if (confirm('Haluatko varmasti siirtää yrityksen ja sen tilaukset toiselle myyjälle?')) {
                store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Yritystä ja sille kohdennetut tilaukset siirretään.", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:true,top:true})
                var url = state.settings.dev ? 'http://0.0.0.0:5000/avecor-709ff/us-central1/updateSalespersonForCompanyId' : 'https://us-central1-avecor-709ff.cloudfunctions.net/updateSalespersonForCompanyId'
                let res = await axios.post(url,{ companyId, newSalesperson})
                store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }
        }
        catch(error){
            let errorMessage = (error && error.response && error.response.data && error.response.data.message) ? error.response.data.message : error;
            store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:errorMessage, snackButtonText: "OK", errorType:"", snackColor:'error',right:true,top:true})
            console.log(error)
        }
      },
    openEasyFirestoreChannels({commit, state}) {
        var rule = {orderBy: ['id']}
        var where = {}
        //console.log(state.user.uid)
        if(state.user.uid === "wcMZF1c4vsMZAmCsXzSDDwh4PJd2" || 
            state.user.uid === "y9ZVH4HpzFWuS9TzONQUJadQZ4T2" || 
            state.user.uid === "p2VRFkTz4JUzqkGoTPUt4CWQAxa2" ||
            state.user.uid === "IrAVKW5YHzPDOrgtbO1iYLinO8B3")  {
            
        }
        else {
            where = { where:[['salesperson', '==', '{userId}']]}
            rule.where = [['salesperson', '==', '{userId}']]
        }
        store.dispatch('showSnack', { snack:true, snackTimeout:0, snackText:"Tietoja ladataan (yritykset, kontaktit, tilaukset...), odota hetki...", snackButtonText: "", errorType:"", snackColor:'deep-blue',right:false,top:false})
        store.dispatch('staff/openDBChannel').then(_ => {
            // Then we can get the groupId:
            const id = store.state.user.uid
            const role = store.state.staff.staff[id].role
            const isAdmin = store.state.staff.staff[id].isAdmin
            
            // Then we can pass it as variable to the next openDBChannel:
            //store.dispatch('order/openDBChannel', {pathVariables: {role:role}})
            //console.log({isAdmin,role})
            var sami_h_uid = 'od6hpMLCPVSywiM17gt2MrIrq0i1'
            var where = []
            var whereOrders = []
            var whereOrderedProducts = []
            let startDateOrdersAll = new Date('2016-09-01');
            let startDateOrderedProductsAll = new Date('2017-01-01');
            /* let startDateOrders = new Date('2023-01-01');
            let startDateOrderedProducts = new Date('2023-02-01'); */
            /* let startDateOrders = new Date('2022-08-01');
            let startDateOrderedProducts = new Date('2023-01-01'); */
            let startDateOrders = new Date('2023-08-01');
            let startDateOrderedProducts = new Date('2023-08-01');
            if(role === 'sales' && !isAdmin) {
                // GTNKFjWUHNhcAJVbORirRPNvCnv1 => ATTE
                whereOrders.push(['salesperson', '==', id])
                whereOrderedProducts.push(['salesperson', '==', id])
            }
            // DATE BASED
            /* else {
                whereOrders.push(['created_at', '>', startDateOrders])
                whereOrderedProducts.push(['created_at', '>', startDateOrderedProducts])
            } */
            else {
                whereOrders.push(['loadOnStart', '==', true])
                whereOrderedProducts.push(['loadOnStart', '==', true])
            }

            if(id === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2-DELETE'){
                console.log("LOADING ALL DATA FOR TOMI")
                whereOrders = []
                whereOrderedProducts = []

                //HANNA TESTAUS
                //whereOrders.push(['salesperson', '==', '2hq19s6eQHSrEhwXiAeDGxo0Q5e2'])
                //whereOrderedProducts.push(['salesperson', '==', '2hq19s6eQHSrEhwXiAeDGxo0Q5e2'])

                //JANNE TESTAUS
                whereOrders.push(['salesperson', '==', 'MG7ysPafpYMEQtqd0HJVzck3yXM2'])
                whereOrderedProducts.push(['salesperson', '==', 'MG7ysPafpYMEQtqd0HJVzck3yXM2'])

                
                /* whereOrders.push(['created_at', '>', startDateOrdersAll])
                whereOrderedProducts.push(['created_at', '>', startDateOrderedProductsAll]) */

                
                //whereOrders.push(['salesperson', '==', 'GTNKFjWUHNhcAJVbORirRPNvCnv1'])
                //whereOrderedProducts.push(['salesperson', '==', 'GTNKFjWUHNhcAJVbORirRPNvCnv1'])
            }
            
            store.dispatch('company/openDBChannel').then(_ => {
                store.dispatch('contact/openDBChannel').then(_ => {
                    // VAIN ATEN TILAUKSET
                    store.dispatch('order/openDBChannel', { where:whereOrders }).then(_ => {
                        store.dispatch('orderedProduct/openDBChannel', { where:whereOrderedProducts }).then(_ => {
                    
                    /* DATE LIMITED */
                    /* store.dispatch('order/openDBChannel', { where: [['created_at', '>', startDateOrders]] }).then(_ => {
                        store.dispatch('orderedProduct/openDBChannel', { where: [['created_at', '>', startDateOrderedProducts]] }).then(_ => { */
                            store.dispatch('pricingVariables/openDBChannel').then(_ => {
                                store.dispatch('product/openDBChannel').then(_ => {
                                    store.dispatch('productVariation/openDBChannel').then(_ => {
                                        store.dispatch('printShop/openDBChannel').then(_ => {
                                            if(role === 'office' || role === 'warehouse' || isAdmin || id === sami_h_uid){
                                                store.dispatch('wholesaleCompany/openDBChannel').then(_ => {
                                                    if(role === 'office' || role === 'warehouse' || isAdmin){
                                                        store.dispatch('otherPartner/openDBChannel').then(_ => {
                                                            commit('setLoaded',true)
                                                            store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Tiedot ladattu!", snackButtonText: "", errorType:"", snackColor:'success',right:false,top:false})  
                                                        })
                                                    }
                                                    else {
                                                        commit('setLoaded',true)
                                                        store.dispatch('showSnack', { snack:true, snackTimeout:10000, snackText:"Tiedot ladattu. Jos tilaus on olemassa olevalle asiakkaalle, valitse asiakas 'Valitse yritys' ja 'Valitse kontakti' pudotusvalikoista. Näin järjestelmään ei kerry useamman kerran samoja yrityksiä!", snackButtonText: "", errorType:"", snackColor:'success',right:false,top:false})        
                                                    }
                                                })
                                            }
                                            else{
                                                commit('setLoaded',true)
                                                store.dispatch('showSnack', { snack:true, snackTimeout:10000, snackText:"Tiedot ladattu. Jos tilaus on olemassa olevalle asiakkaalle, valitse asiakas 'Valitse yritys' ja 'Valitse kontakti' pudotusvalikoista. Näin järjestelmään ei kerry useamman kerran samoja yrityksiä!", snackButtonText: "", errorType:"", snackColor:'success',right:false,top:false})
                                            }  
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    },
    async userSignOut ({commit,state}) {
        var uid = state.user.uid
        console.log(uid)
        var date = new Date()
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        var d = date.getDate()
        /* var data = {[y]:{
            [m]:{
                [d]:{
                    [uid]:{
                        logout:firebase.firestore.FieldValue.arrayUnion(date)
                    }
                }
            }
        }}
        var db = firebase.firestore();
        await db.collection('config').doc('logs').set({ 
            data
        }, { merge: true }) */

        var year = {
            [m]:{
                [d]:{
                    [uid]:{
                        logout:firebase.firestore.FieldValue.arrayUnion(date)
                    }
                }
            }
        }
        var db = firebase.firestore();
        db.collection('config').doc('logs').set({ 
            [y]:year
        }, { merge: true })

        setTimeout(() =>{
            firebase.auth().signOut().then(function() {
                console.log("SIGNED OUT")
                //gapi && gapi.auth2 && gapi.auth2.getAuthInstance() ? gapi.auth2.getAuthInstance().signOut() : null
                var email = state.user.email ? state.user.email : ""
                state.settings.debug ? console.log("LOGGING OUT: "+ email) : null
                
                commit('setUser', "")
                commit('setSalesperson', null)
                commit('setUnauthenticatedUserMessage', true)
                //router.go()
                //window.open(window.location.href,"_self")
                //window.location.href
                location.reload(true)
              }, function(error) {
                // An error happened.
              }
            );
        }, 500);
    },
    generateOrderedProductsStatuses({commit,state}, payload) {
        var orderStatuses = {}
        Object.keys(state.orderedProduct.orderedProducts).map(function(key, index) {
          var op = state.orderedProduct.orderedProducts[key]
          typeof orderStatuses[op.orderId] === "undefined" ? orderStatuses[op.orderId] = [] : ""
          //if(key==="hny4Tefs5g245OsLs9Tw") console.log(op)
          orderStatuses[op.orderId].push({id: op.id, deliveryStatus:op.orderStatus, invoiceStatus:op.orderInvoiceStatus}) 
          return {}
        })
        //console.log(state.orderedProduct.orderedProducts)
        commit('setOrderedProductsStatuses', orderStatuses)
        
    },
    newRow ({commit,state}, payload) {
        //payload.productId === "" ? payload.productId = "Ei määritelty" : null
        commit('newRow', payload)
    },
    addProductToPromotion ({commit,state}, payload) {
        //payload.productId === "" ? payload.productId = "Ei määritelty" : null
        commit('addProductToPromotion', payload)
    },
    
    addPriceOfferToProduct({commit,state}, payload) {
        commit('addPriceOfferToProduct', payload)
    },
    deletePriceOfferFromProduct({commit,state}, payload) {
        commit('deletePriceOfferFromProduct', payload)
    },
    deleteProductFromPromotion({commit, state}, payload) {
        var p = state.newPromotionDetails.products
        var pe =state.newPromotionDetails.productsErrors
        var products = []
        var productsErrors = []
        for (var i = 0; i < p.length; i++) {
            if(payload.productNumber != i) {
                products.push(p[i])
                productsErrors.push(pe[i])
            }
        }
        commit('updatePromotionProducts', {products, productsErrors})
    },
    updateRow ({commit, state}, payload) {
        var updateIndex = -1
        var p = state.newOrderDetails.products
        //console.log(p)
        for (var i=0; i < p.length; i++) {
            //console.log("payload number:" + payload.number + "   products number:"+p[i].number)
            if (p[i].number == payload.number) {
                updateIndex = i; 
            }
        }
        updateIndex != -1 ? commit('updateRow', { index:updateIndex, ...payload}) : null
    },
    updateProductVariationMediaArray ({commit, state}, payload) {
        commit('setProductVariationMediaArray', { ...payload })
    },
    updateOrderedProductDraftsArray ({commit, state}, payload) {
        commit('updateOrderedProductDraftsArray', { ...payload })
    },
    showSnack ({commit, state}, payload) {
        commit('snackSettingsUpdate', { ...payload })
    },
    clickedSnackCloseButton ({commit, state}) {
        commit('snackSettingsUpdate', { snack:false })
        //tate.settings.snackSettings.errorType === 'gmailAuth' ? console.log("REAUTHENTICATING") : null
        //state.settings.snackSettings.errorType === 'gmailAuth' ? gapi.auth2.getAuthInstance().signIn({ux_mode:"redirect"}) : null
        
        state.settings.snackSettings.errorType === 'gmailAuth' && state.device === 'desktop' ? gapi.auth2.getAuthInstance().signIn() : null
        state.settings.snackSettings.errorType === 'gmailAuth' && state.device === 'mobile' ? gapi.auth2.getAuthInstance().signIn({ux_mode:"popup"}) : null
    },
    deleteRow ({commit, state}, number) {
        var p =state.newOrderDetails.products2
        //p = p.splice(number, 1)
        var products = []
        for (var i = 0; i < p.length; i++) {
            number != i ? products.push(p[i]) : ""
        }
        commit('updateProducts', products)
    },
    resetProducts ({commit, state}, payload) {
        commit('updateProducts', [])
    },
    resetPromotionProducts ({commit, state}, payload) {
        commit('updatePromotionProducts', {products:[], productsErrors:[]})
    },
    setUrlId({commit, state}, payload) {
        commit('setUrlId', payload.urlId)
    },
    setLoadingOverlay({commit, state}, payload) {
        commit('setLoadingOverlay', payload)
    },
    setViewAndSearch({commit, state}, payload) {
        commit('setView', payload)
        commit('setSearch', payload)
    },
    deleteRowOld ({commit, state}, number) {
        var deleteIndex = -1
        var p = state.newOrderDetails.products
        for (var i=0; i < p.length; i++) {
            //console.log("payload number:" + i + "   products number:"+p[i].number)
            if (p[i].number == number) {
                deleteIndex = i; 
            }
        }
        deleteIndex != -1 ? commit('deleteRow', deleteIndex) : null
    }
    
  },
  getters: {
    getField, 
    products(state){
        return state.product.products
    },
    productVariations(state){
        return state.productVariation.productVariations
    },
    productVariationById: (state) => (id) => {
        return state.productVariation.productVariations[id] !== undefined ? state.productVariation.productVariations[id] : null
    },
    getProductVariationFiles: (state) => (id) => {
        console.log(id)
        console.log(state.productVariation.productVariations[id].medias)
        return state.productVariation.productVariations[id] !== undefined && state.productVariation.productVariations[id].media !== undefined ? state.productVariation.productVariations[id].media : []
    },
    getOrderedProductFiles: (state) => (id) => {
        console.log(id)
        console.log(state.orderedProduct.orderedProducts[id].drafts)
        return state.orderedProduct.orderedProducts[id].drafts !== undefined && state.orderedProduct.orderedProducts[id].drafts !== undefined ? state.orderedProduct.orderedProducts[id].drafts : []
    },
    isAuthenticated (state) {
        return state.user !== null && state.user !== undefined && state.user !== ""
    },
    getUser(state) {
        return state.user
    }
  },
  plugins: [easyFirestore]
})



// WEBPACK FOOTER //
// ./src/store/index.js